"use client";

import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';


const authFetch = async (url: string, options: any = {}) => {
  const token = typeof window !== 'undefined' ? (localStorage.getItem('adminToken') || localStorage.getItem('userToken')) : null;
  const headers = { ...options.headers };
  if (token) headers['Authorization'] = `Bearer ${token}`;

  const res = await fetch(url, { ...options, headers });
  if (res.status === 401 || res.status === 403) {
    if (typeof window !== 'undefined') {
      localStorage.removeItem('adminToken');
      localStorage.removeItem('usuario');
      localStorage.removeItem('userToken');
      window.location.href = '/login';
    }
  }
  return res;
};


function formatarCPF(valor: string) {
  return valor
    .replace(/\D/g, '') // Remove tudo o que não é dígito
    .replace(/(\d{3})(\d)/, '$1.$2') // Adiciona o primeiro ponto
    .replace(/(\d{3})(\d)/, '$1.$2') // Adiciona o segundo ponto
    .replace(/(\d{3})(\d{1,2})/, '$1-$2') // Adiciona o traço
    .replace(/(-\d{2})\d+?$/, '$1'); // Impede que passe do limite (14 caracteres)
}

function formatarCelular(valor: string) {
  const v = valor.replace(/\D/g, ''); // Remove tudo que não for número
  if (v.length <= 2) return v;
  if (v.length <= 7) return `(${v.slice(0, 2)}) ${v.slice(2)}`;
  return `(${v.slice(0, 2)}) ${v.slice(2, 7)}-${v.slice(7, 11)}`;
}

export default function PainelPage() {
  const router = useRouter();


  const [usuario, setUsuario] = useState<any>(null);
  const [eventos, setEventos] = useState<any[]>([]);
  const [presencas, setPresencas] = useState<number[]>([]);
  const [aniversariantes, setAniversariantes] = useState<any[]>([]);
  const [imagemModal, setImagemModal] = useState<string | null>(null);
  const [activeTab, setActiveTab] = useState('meu_perfil');
  const [menuAberto, setMenuAberto] = useState<string | null>(null);

  const irParaAba = (aba: string) => {
    setActiveTab(aba);
    setMenuAberto(null);
  };

  useEffect(() => {
    if (menuAberto === 'mobile') {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [menuAberto]);

  const [pagamentosSocio, setPagamentosSocio] = useState<any[]>([]);
  const [pedidosLoja, setPedidosLoja] = useState<any[]>([]);
  const [convidadosSocio, setConvidadosSocio] = useState<any[]>([]);
  const [dependentesSocio, setDependentesSocio] = useState<any[]>([]);
  const [isSenhaModalOpen, setIsSenhaModalOpen] = useState(false);
  const [isUpgradeModalOpen, setIsUpgradeModalOpen] = useState(false);
  const [isConvidadoModalOpen, setIsConvidadoModalOpen] = useState(false);
  const [isDependenteModalOpen, setIsDependenteModalOpen] = useState(false);
  const [convidadoNome, setConvidadoNome] = useState('');
  const [convidadoCpf, setConvidadoCpf] = useState('');
  const [erroConvidado, setErroConvidado] = useState('');
  const [dependenteNome, setDependenteNome] = useState('');
  const [dependenteCpf, setDependenteCpf] = useState('');
  const [dependenteParentesco, setDependenteParentesco] = useState('');
  const [dependenteNascimento, setDependenteNascimento] = useState('');
  const [erroDependente, setErroDependente] = useState('');

  const [senhaAtual, setSenhaAtual] = useState('');
  const [novaSenha, setNovaSenha] = useState('');
  const [confirmarNovaSenha, setConfirmarNovaSenha] = useState('');
  const [erroSenha, setErroSenha] = useState('');
  const [temFilhosSelecionado, setTemFilhosSelecionado] = useState<string | null>(null);

  // Estados para Pagamento de Mensalidade via Mercado Pago
  const [isPagamentoMensalidadeModalOpen, setIsPagamentoMensalidadeModalOpen] = useState(false);
  const [loadingPagamentoMensalidade, setLoadingPagamentoMensalidade] = useState<'recorrente' | 'avulso' | null>(null);
  const [mensagemPagamento, setMensagemPagamento] = useState<string | null>(null);

  // Estado para controlar o giro (flip) da carteirinha
  const [isFlipped, setIsFlipped] = useState(false);
  const [isApp, setIsApp] = useState(false);
  const [deferredPrompt, setDeferredPrompt] = useState<any>(null);

  useEffect(() => {
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone;
    if (window.location.search.includes('app=true') || isStandalone) {
      setIsApp(true);
    }

    // Verifica se o usuário está logado ao carregar a página
    const userStr = localStorage.getItem('usuario');
    if (!userStr) {
      // Se não tiver registro, manda de volta pro login
      router.push('/login');
    } else {
      const userObj = JSON.parse(userStr);
      setUsuario(userObj);

      // Busca dados atualizados do usuário (para não precisar relogar se houver mudança de status)
      authFetch(`https://api.arfainfo.com.br/api/usuarios/${userObj.id}`)
        .then(res => res.json())
        .then(data => {
          if (data.sucesso) {
            setUsuario(data.usuario);
            localStorage.setItem('usuario', JSON.stringify(data.usuario));
          }
        })
        .catch(err => console.error("Erro ao atualizar usuário:", err));

      // Sincroniza retorno do Mercado Pago se houver preapproval_id na URL
      if (typeof window !== 'undefined') {
        const urlParams = new URLSearchParams(window.location.search);
        const preapprovalId = urlParams.get('preapproval_id') || urlParams.get('id');
        if (preapprovalId) {
          authFetch('https://api.arfainfo.com.br/api/mercadopago/sincronizar-assinatura', {
            method: 'POST',
            body: JSON.stringify({ preapprovalId })
          })
            .then(res => res.json())
            .then(syncData => {
              if (syncData.sucesso && syncData.autorizado) {
                authFetch(`https://api.arfainfo.com.br/api/usuarios/${userObj.id}`)
                  .then(r => r.json())
                  .then(uData => {
                    if (uData.sucesso) {
                      setUsuario(uData.usuario);
                      localStorage.setItem('usuario', JSON.stringify(uData.usuario));
                    }
                  });
              }
            })
            .catch(err => console.error("Erro ao sincronizar assinatura:", err));
        }
      }

      // Busca os eventos do calendário
      authFetch('https://api.arfainfo.com.br/api/eventos')
        .then(res => res.json())
        .then(data => {
          if (data.sucesso) setEventos(data.dados);
        })
        .catch(err => console.error("Erro ao buscar eventos:", err));

      // Busca os eventos que o usuário já confirmou
      authFetch(`https://api.arfainfo.com.br/api/presencas/${userObj.id}`)
        .then(res => res.json())
        .then(data => {
          if (data.sucesso) setPresencas(data.dados);
        })
        .catch(err => console.error("Erro ao buscar presenças:", err));

      // Busca o histórico de pagamentos do usuário
      authFetch(`https://api.arfainfo.com.br/api/usuarios/${userObj.id}/pagamentos`)
        .then(res => res.json())
        .then(data => {
          if (data.sucesso) setPagamentosSocio(data.dados);
        })
        .catch(err => console.error("Erro ao buscar pagamentos:", err));

      // Busca a lista de convidados do usuário
      authFetch(`https://api.arfainfo.com.br/api/usuarios/${userObj.id}/convidados`)
        .then(res => res.json())
        .then(data => {
          if (data.sucesso) setConvidadosSocio(data.dados);
        })
        .catch(err => console.error("Erro ao buscar convidados:", err));

      // Busca a lista de dependentes do usuário
      authFetch(`https://api.arfainfo.com.br/api/usuarios/${userObj.id}/dependentes`)
        .then(res => res.json())
        .then(data => {
          if (data.sucesso) setDependentesSocio(data.dados);
        })
        .catch(err => console.error("Erro ao buscar dependentes:", err));

      // Busca os pedidos da loja do usuário
      authFetch(`https://api.arfainfo.com.br/api/usuarios/${userObj.id}/pedidos`)
        .then(res => res.json())
        .then(data => {
          if (data.sucesso) setPedidosLoja(data.dados);
        })
        .catch(err => console.error("Erro ao buscar pedidos da loja:", err));

      // Busca os aniversariantes do mês
      authFetch('https://api.arfainfo.com.br/api/aniversariantes')
        .then(res => res.json())
        .then(data => {
          if (data.sucesso) setAniversariantes(data.dados);
        })
        .catch(err => console.error("Erro ao buscar aniversariantes:", err));
    }
  }, [router]);

  useEffect(() => {
    // Registra o Service Worker (Motor Offline)
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.register('/sw.js').catch(() => { });
    }
    // Injeta o arquivo do App no navegador
    if (!document.querySelector('link[rel="manifest"]')) {
      const link = document.createElement('link');
      link.rel = 'manifest';
      link.href = '/manifest.json';
      document.head.appendChild(link);
    }
    // Ouve se o celular permitiu mostrar o botão de Instalação (PWA)
    const handleBeforeInstallPrompt = (e: any) => { e.preventDefault(); setDeferredPrompt(e); };
    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    return () => window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
  }, []);

  useEffect(() => {
    // Se o usuário precisa trocar a senha, abre o modal automaticamente
    if (usuario?.precisaTrocarSenha) {
      setIsSenhaModalOpen(true);
      setSenhaAtual('123456'); // Preenche a senha atual para facilitar
    }
  }, [usuario]);

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const toggle = document.getElementById('cgt-menu-toggle') as HTMLInputElement | null;
      if (!toggle || !toggle.checked) return;
      const target = e.target as HTMLElement;
      const isLink = target.closest('.cgt-nav a');
      const isNav = target.closest('.cgt-nav');
      const isHamburger = target.closest('.cgt-hamburger');
      const isToggle = target === toggle;
      if (isLink || (!isNav && !isHamburger && !isToggle)) {
        toggle.checked = false;
      }
    };
    window.addEventListener('click', handleClick);
    return () => window.removeEventListener('click', handleClick);
  }, []);

  const handleLogout = () => {
    localStorage.removeItem('usuario'); // Apaga o registro
    router.push('/login'); // Volta pro login
  };

  const handleConfirmar = async (eventoId: number) => {
    try {
      const res = await authFetch('https://api.arfainfo.com.br/api/presencas', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ usuario_id: usuario.id, evento_id: eventoId })
      });
      const data = await res.json();
      if (data.sucesso) {
        setPresencas([...presencas, eventoId]);
        alert("Sua presença foi confirmada com sucesso!");
      } else {
        alert(data.mensagem || "Erro ao confirmar.");
      }
    } catch (err) {
      alert("Erro de conexão.");
    }
  };

  const handleDesconfirmar = async (eventoId: number) => {
    if (!confirm("Deseja realmente cancelar sua presença neste evento?")) return;

    try {
      const res = await authFetch(`https://api.arfainfo.com.br/api/presencas/${usuario.id}/${eventoId}`, {
        method: 'DELETE'
      });
      const data = await res.json();
      if (data.sucesso) {
        setPresencas(presencas.filter(id => id !== eventoId));
        alert("Sua presença foi cancelada com sucesso!");
      } else {
        alert(data.mensagem || "Erro ao cancelar.");
      }
    } catch (err) {
      alert("Erro de conexão.");
    }
  };

  const handleFotoUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const formData = new FormData();
    formData.append('foto', file);

    try {
      const res = await authFetch(`https://api.arfainfo.com.br/api/usuarios/${usuario.id}/foto`, {
        method: 'POST',
        body: formData
      });
      const data = await res.json();
      if (data.sucesso) {
        const userAtualizado = { ...usuario, foto_url: data.foto_url };
        setUsuario(userAtualizado);
        localStorage.setItem('usuario', JSON.stringify(userAtualizado));
      } else {
        alert(data.mensagem || 'Erro ao enviar a foto.');
      }
    } catch (err) {
      alert('Erro de conexão ao enviar a foto.');
    }
  };

  const handleAtualizarPerfil = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const perfilData = Object.fromEntries(formData.entries());

    try {
      const res = await authFetch(`https://api.arfainfo.com.br/api/usuarios/${usuario.id}/perfil`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(perfilData)
      });
      const data = await res.json();
      if (data.sucesso) {
        alert('Perfil atualizado com sucesso!');
        // Atualiza a tela com os dados novos e salva no navegador
        setUsuario({ ...usuario, ...perfilData });
        localStorage.setItem('usuario', JSON.stringify({ ...usuario, ...perfilData }));
      } else {
        alert(data.mensagem || 'Erro ao atualizar perfil.');
      }
    } catch (err) {
      alert('Erro de conexão ao atualizar perfil.');
    }
  };

  const handleAdicionarConvidado = async (e: React.FormEvent) => {
    e.preventDefault();
    setErroConvidado('');
    try {
      const res = await authFetch('https://api.arfainfo.com.br/api/convidados', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ usuario_id: usuario.id, nome: convidadoNome, cpf: convidadoCpf })
      });
      const data = await res.json();
      if (data.sucesso) {
        alert('Convidado adicionado com sucesso!');
        setIsConvidadoModalOpen(false);
        setConvidadoNome(''); setConvidadoCpf('');
        authFetch(`https://api.arfainfo.com.br/api/usuarios/${usuario.id}/convidados`).then(r => r.json()).then(d => { if (d.sucesso) setConvidadosSocio(d.dados); });
      } else {
        setErroConvidado(data.mensagem || 'Erro ao adicionar convidado.');
      }
    } catch (err) {
      setErroConvidado('Erro de conexão ao adicionar convidado.');
    }
  };

  const handleRemoverConvidado = async (id: number) => {
    if (!confirm("Deseja realmente remover este convidado?")) return;
    try {
      const res = await authFetch(`https://api.arfainfo.com.br/api/convidados/${id}`, { method: 'DELETE' });
      if (res.ok) setConvidadosSocio(convidadosSocio.filter(c => c.id !== id));
    } catch (err) { }
  };

  const handleAdicionarDependente = async (e: React.FormEvent) => {
    e.preventDefault();
    setErroDependente('');
    try {
      const res = await authFetch('https://api.arfainfo.com.br/api/dependentes', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ usuario_id: usuario.id, nome: dependenteNome, cpf: dependenteCpf, parentesco: dependenteParentesco, nascimento: dependenteNascimento })
      });
      const data = await res.json();
      if (data.sucesso) {
        alert('Dependente adicionado com sucesso!');
        setIsDependenteModalOpen(false);
        setDependenteNome(''); setDependenteCpf(''); setDependenteParentesco(''); setDependenteNascimento('');
        authFetch(`https://api.arfainfo.com.br/api/usuarios/${usuario.id}/dependentes`).then(r => r.json()).then(d => { if (d.sucesso) setDependentesSocio(d.dados); });
      } else {
        setErroDependente(data.mensagem || 'Erro ao adicionar dependente.');
      }
    } catch (err) {
      setErroDependente('Erro de conexão ao adicionar dependente.');
    }
  };

  const handleRemoverDependente = async (id: number) => {
    if (!confirm("Deseja realmente remover este dependente?")) return;
    try {
      const res = await authFetch(`https://api.arfainfo.com.br/api/dependentes/${id}`, { method: 'DELETE' });
      if (res.ok) setDependentesSocio(dependentesSocio.filter(d => d.id !== id));
    } catch (err) { }
  };

  const handleAlterarSenha = async (e: React.FormEvent) => {
    e.preventDefault();
    setErroSenha('');
    if (novaSenha !== confirmarNovaSenha) {
      return setErroSenha('As novas senhas não coincidem. Digite novamente.');
    }
    try {
      const res = await authFetch(`https://api.arfainfo.com.br/api/usuarios/${usuario.id}/senha`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ senhaAtual, novaSenha })
      });
      const data = await res.json();
      if (data.sucesso) {
        alert('Sua senha foi alterada com segurança!');
        setIsSenhaModalOpen(false);
        setSenhaAtual('');
        setNovaSenha('');
        setConfirmarNovaSenha('');

        if (usuario.precisaTrocarSenha) {
          const userAtualizado = { ...usuario, precisaTrocarSenha: false };
          setUsuario(userAtualizado);
          localStorage.setItem('usuario', JSON.stringify(userAtualizado));
        }
      } else {
        setErroSenha(data.mensagem || 'Erro ao alterar senha.');
      }
    } catch (err) {
      setErroSenha('Erro de conexão ao alterar senha.');
    }
  };

  const solicitarUpgradeWhatsApp = (novoPlano: string) => {
    const planoAtual = usuario.plano || 'Guerreiro da Casa';
    const msg = encodeURIComponent(`Olá! Sou o sócio ${usuario.nome} e gostaria de solicitar a mudança do meu plano atual (${planoAtual}) para a categoria *${novoPlano}*. Como devo proceder?`);
    window.open(`https://wa.me/5521996907307?text=${msg}`, '_blank');
  };

  const handleExportarWallet = () => {
    window.open(`https://api.arfainfo.com.br/api/usuarios/${usuario.id}/wallet`, '_blank');
  };

  const handleExportarGoogleWallet = () => {
    window.open(`https://api.arfainfo.com.br/api/usuarios/${usuario.id}/google-wallet`, '_blank');
  };

  const getValorPlanoAtual = () => {
    if (!usuario?.plano) return 50.00;
    if (usuario.plano === 'Sangue Grená') return 90.00;
    if (usuario.plano === 'Lenda Tricolor') return 120.00;
    return 50.00;
  };

  const handlePagarMensalidadeRecorrente = async () => {
    setLoadingPagamentoMensalidade('recorrente');
    setMensagemPagamento(null);
    try {
      const res = await authFetch('https://api.arfainfo.com.br/api/mercadopago/criar-assinatura-recorrente', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ plano: usuario.plano })
      });
      const data = await res.json();
      if (data.sucesso) {
        if (data.init_point) {
          window.location.href = data.init_point;
          return;
        } else {
          setMensagemPagamento(data.mensagem || "O gateway Mercado Pago está ativo e aguardando a configuração do Access Token no servidor.");
        }
      } else {
        setMensagemPagamento(data.mensagem || "Erro ao processar assinatura recorrente.");
      }
    } catch (e) {
      setMensagemPagamento("Erro de conexão com o servidor de pagamento.");
    } finally {
      setLoadingPagamentoMensalidade(null);
    }
  };

  const handlePagarMensalidadeAvulsa = async () => {
    setLoadingPagamentoMensalidade('avulso');
    setMensagemPagamento(null);
    try {
      const res = await authFetch('https://api.arfainfo.com.br/api/mercadopago/criar-preferencia-mensalidade', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ plano: usuario.plano })
      });
      const data = await res.json();
      if (data.sucesso) {
        if (data.init_point) {
          window.location.href = data.init_point;
          return;
        } else {
          setMensagemPagamento(data.mensagem || "O gateway Mercado Pago está ativo e aguardando a configuração do Access Token no servidor.");
        }
      } else {
        setMensagemPagamento(data.mensagem || "Erro ao processar cobrança.");
      }
    } catch (e) {
      setMensagemPagamento("Erro de conexão com o servidor de pagamento.");
    } finally {
      setLoadingPagamentoMensalidade(null);
    }
  };

  const handleExportarPDF = async () => {
    try {
      // Importa as bibliotecas
      // @ts-ignore
      const htmlToImage = await import('html-to-image');
      // @ts-ignore
      const { jsPDF } = await import('jspdf');

      const frente = document.getElementById('carteirinha-frente');
      const verso = document.getElementById('carteirinha-verso');
      if (!frente || !verso) return;

      // Ocultar as setas de virar temporariamente
      const botoes = document.querySelectorAll('.btn-virar-carteira');
      botoes.forEach((b: any) => b.style.display = 'none');

      // Tirar a rotação 3D do verso temporariamente para não sair espelhado no PDF
      const oldTransform = verso.style.transform;
      verso.style.transform = 'none';

      // Pequeno atraso para aplicar as alterações na interface
      await new Promise(resolve => setTimeout(resolve, 50));

      const imgFrente = await htmlToImage.toPng(frente, { pixelRatio: 3, backgroundColor: '#ffffff' });
      const imgVerso = await htmlToImage.toPng(verso, { pixelRatio: 3, backgroundColor: '#ffffff' });

      // Restaurar o visual
      verso.style.transform = oldTransform;
      botoes.forEach((b: any) => b.style.display = '');

      const pdf = new jsPDF({ orientation: 'landscape', unit: 'px', format: [820, 250] });
      pdf.addImage(imgFrente, 'PNG', 0, 0, 400, 250);
      pdf.addImage(imgVerso, 'PNG', 420, 0, 400, 250);
      pdf.save(`Carteirinha_CGT_${usuario.nome.replace(/\s+/g, '_')}.pdf`);
    } catch (error) {
      console.error("Erro ao gerar PDF:", error);
      alert("Erro ao gerar PDF. Certifique-se de instalar as dependências rodando: npm install html-to-image jspdf");
    }
  };

  const handleInstalarApp = async () => {
    if (deferredPrompt) {
      deferredPrompt.prompt(); // Mostra o pop-up nativo do Android
      const { outcome } = await deferredPrompt.userChoice;
      if (outcome === 'accepted') setDeferredPrompt(null);
    } else {
      // Fallback amigável para iPhones (iOS não permite o pop-up automático)
      alert('📱 Para instalar no iPhone (iOS):\n\n1. Toque no botão "Compartilhar" do Safari (um quadradinho com uma seta para cima na barra inferior).\n2. Selecione "Adicionar à Tela de Início".\n\nNo Android:\nSe o aviso não apareceu, clique nos 3 pontinhos do Chrome e escolha "Instalar Aplicativo" ou "Adicionar à tela inicial".');
    }
  };

  // Mostra "Carregando" na tela enquanto o useEffect lê o localStorage
  if (!usuario) return <div className="min-h-screen bg-gray-50 flex items-center justify-center font-bold text-gray-500">Carregando...</div>;

  // MODO PWA (APLICATIVO INSTALADO)
  if (isApp && usuario) {
    return (
      <div className="cgt-root font-sans text-gray-900 min-h-screen flex flex-col items-center justify-center p-4 gap-6">
        <link href="https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Montserrat:ital,wght@0,400;0,600;0,700;0,800;0,900;1,400;1,800&display=swap" rel="stylesheet" />


        {/* FRENTE DA CARTEIRINHA */}
        <div className="w-full max-w-[400px] h-[250px] bg-white rounded-2xl shadow-xl border border-gray-200 relative overflow-hidden">
          <div className="w-full h-full rounded-2xl p-5 pb-6 flex flex-col justify-between overflow-hidden relative">
            <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#006437] via-white to-[#8A1538]"></div>
            <div className="absolute -bottom-10 -right-10 opacity-[0.03] pointer-events-none">
              <img src="https://casadoguerreirotricolor.com.br/logo_pre.png" alt="Watermark" crossOrigin="anonymous" className="w-64 object-contain grayscale" />
            </div>
            <div className="flex justify-between items-start relative z-10">
              <div>
                <span className="text-[10px] font-black uppercase tracking-widest text-[#8A1538]">Carteira de Sócio</span>
                <h3 className="text-xl font-black text-gray-900 uppercase leading-none mt-1 tracking-tighter italic">Casa do Guerreiro</h3>
              </div>
            </div>
            <div className="flex gap-4 items-center relative z-10 mt-3 flex-grow">
              <div className="relative shrink-0 w-[80px] h-[105px] bg-gray-50 border border-gray-200 shadow-sm overflow-hidden rounded-lg">
                {usuario.foto_url ? (
                  <img src={usuario.foto_url} alt="Sócio" crossOrigin="anonymous" className="w-full h-full object-cover" />
                ) : (
                  <div className="w-full h-full flex items-center justify-center text-gray-300 text-3xl">👤</div>
                )}
              </div>
              <div className="flex flex-col justify-center space-y-2 flex-1">
                <div>
                  <p className="text-[10px] font-bold text-[#006437] uppercase tracking-wider mb-0.5">Nome do Titular</p>
                  <p className="font-black text-[13px] text-gray-800 uppercase leading-tight line-clamp-2 pr-1" title={usuario.nome}>{usuario.nome}</p>
                </div>
                <div className="grid grid-cols-2 gap-2">
                  <div>
                    <p className="text-[9px] font-bold text-gray-500 uppercase tracking-wider mb-0.5">Matrícula</p>
                    <p className="font-bold text-xs text-gray-900">#{String(usuario.id).padStart(5, '0')}</p>
                  </div>
                  <div>
                    <p className="text-[9px] font-bold text-gray-500 uppercase tracking-wider mb-0.5">Admissão</p>
                    <p className="font-bold text-xs text-gray-900">{usuario.data_cadastro ? new Date(usuario.data_cadastro).toLocaleDateString('pt-BR') : '04/02/2019'}</p>
                  </div>
                </div>
              </div>
              <div className="shrink-0 flex flex-col items-center">
                <div className="bg-white p-1 border border-gray-200 rounded-lg shadow-sm">
                  <img src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=CGT-${String(usuario.id).padStart(5, '0')}&color=000000`} alt="QR Code" crossOrigin="anonymous" className="h-16 w-16 object-contain" />
                </div>
                <p className="text-[8px] font-bold text-gray-400 mt-1.5 uppercase tracking-widest">Acesso</p>
              </div>
            </div>
            <div className="mt-2 pt-3 border-t border-gray-100 flex justify-between items-end relative z-10">
              <div>
                <p className="text-[9px] font-bold text-gray-400 uppercase tracking-wider mb-0.5">Plano Vigente</p>
                <p className="font-black text-xs uppercase text-[#8A1538]">{usuario.plano || 'Guerreiro da Casa'}</p>
              </div>
              <div className="text-right flex items-center gap-1.5">
                <span className={`relative flex h-2.5 w-2.5`}><span className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${usuario.status_socio === 'ativo' ? 'bg-[#00c96e]' : 'bg-yellow-400'}`}></span><span className={`relative inline-flex rounded-full h-2.5 w-2.5 ${usuario.status_socio === 'ativo' ? 'bg-[#00c96e]' : 'bg-yellow-500'}`}></span></span>
                <p className={`font-black text-xs uppercase tracking-wider ${usuario.status_socio === 'ativo' ? 'text-[#006437]' : 'text-yellow-600'}`}>{usuario.status_socio || 'Inativo'}</p>
              </div>
            </div>
          </div>
        </div>

        {/* VERSO DA CARTEIRINHA */}
        <div className="w-full max-w-[400px] h-[250px] bg-white rounded-2xl shadow-xl border border-gray-200 relative overflow-hidden">
          <div className="w-full h-full rounded-2xl p-6 flex flex-col items-center justify-center overflow-hidden relative">
            <div className="absolute bottom-0 left-0 w-full h-2 bg-gradient-to-r from-[#8A1538] via-white to-[#006437]"></div>
            <img src="https://casadoguerreirotricolor.com.br/logo_pre.png" alt="Logo Sócio" className="w-36 object-contain relative z-10 mb-4" />
            <div className="text-center relative z-10">
              <p className="font-black text-lg sm:text-xl text-gray-800 uppercase tracking-tight">Sócio Casa do Guerreiro Tricolor Nova Iguaçu/RJ</p>
            </div>
          </div>
        </div>

        {/* BOTÃO DE SAIR NO APP */}
        <button onClick={handleLogout} className="mt-4 text-[10px] font-bold text-gray-500 uppercase tracking-widest hover:text-[#8A1538] transition border border-gray-300 bg-white/50 rounded px-4 py-2 hover:bg-gray-200/50">
          Sair da Conta
        </button>
      </div>
    );
  }

  let limiteConvidados = 0;
  if (usuario.plano === 'Sangue Grená') limiteConvidados = 2;
  if (usuario.plano === 'Lenda Tricolor') limiteConvidados = 3;

  // Lógica da Topbar Dinâmica
  const proximoEvento = eventos.length > 0 ? eventos[0] : null;
  let topbarTexto = 'BRASIL X HAITI | FESTA JUNINA | 19/06 | 18H';
  if (proximoEvento) {
    const dataFormated = new Date(proximoEvento.data_evento).toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit' });
    topbarTexto = `${proximoEvento.titulo.toUpperCase()} | ${proximoEvento.tipo.toUpperCase()} | ${dataFormated}`;
  }

  const tabTitles: Record<string, string> = {
    meu_perfil: 'Meu Perfil',
    meu_plano: 'Meu Plano',
    pagamentos: 'Pagamentos',
    dependentes: 'Dependentes',
    convidados: 'Convidados',
    aniversariantes: 'Aniversariantes',
    eventos: 'Calendário',
    pedidos: 'Pedidos da Loja'
  };

  return (
    <div className="cgt-root font-sans text-gray-900 flex flex-col min-h-screen">
      <link href="https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Montserrat:ital,wght@0,400;0,600;0,700;0,800;0,900;1,400;1,800&display=swap" rel="stylesheet" />
      <style dangerouslySetInnerHTML={{
        __html: `
        
        .cgt-root { 
          min-height: 100vh; 
          font-family: 'Montserrat', sans-serif; 
          background-color: #e3e2de; 
          background-image: url('https://www.transparenttextures.com/patterns/concrete-wall.png'); 
          color: #111111;
        }
        .cgt-container { max-width: 1200px; margin-left: auto; margin-right: auto; padding-left: 20px; padding-right: 20px; }
        .cgt-title-font { font-family: 'Bebas Neue', 'Impact', sans-serif; letter-spacing: 0.02em; }
        
        /* ── TOPBAR (PRETA) ── */
        .cgt-topbar { background-color: #6b1122; color: #fff; padding: 10px 24px; display: flex; align-items: center; justify-content: space-between; font-size: 0.65rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em; z-index: 60; position: relative; }
        .cgt-topbar-left { display: flex; align-items: center; gap: 8px; }
        .cgt-topbar-dot { color: #00c96e; font-size: 1rem; line-height: 0; margin-top: -2px; }
        .cgt-topbar-event { color: #00c96e; font-weight: 900; }
        .cgt-topbar-right { display: flex; align-items: center; gap: 24px; }
        .cgt-socials { display: flex; gap: 14px; align-items: center; }
        .cgt-socials a { color: #fff; text-decoration: none; display: flex; align-items: center; opacity: 0.8; transition: opacity 0.2s; }
        .cgt-socials a:hover { opacity: 1; color: #6b1122; }
        .cgt-area-btn { border: 1px solid #444; padding: 6px 14px; color: #fff; text-decoration: none; display: flex; align-items: center; gap: 6px; font-weight: 700; transition: 0.2s; }
        .cgt-area-btn:hover { background: #fff; color: #000; }

        /* ── DIVISORES DE SEÇÃO ORNAMENTADOS ◆ ── */
        .cgt-section-header { display: flex; align-items: center; justify-content: center; gap: 20px; margin-bottom: 30px; }
        .cgt-section-line { height: 1px; background: #c2b59b; flex: 1; max-width: 300px; position: relative; }
        .cgt-section-line::after { content: '◆'; position: absolute; top: -7px; color: #c2b59b; font-size: 10px; }
        .cgt-section-line.left::after { right: 0; }
        .cgt-section-line.right::after { left: 0; }
        .cgt-section-title { font-size: 1.2rem; font-weight: 800; color: #333; text-transform: uppercase; letter-spacing: 0.1em; }

        .cgt-header { background: rgba(255,255,255,0.96); backdrop-filter: blur(5px); border-bottom: 1px solid #dcdcdc; position: sticky; top: 0; z-index: 50; box-shadow: 0 2px 10px rgba(0,0,0,0.02); }
        .cgt-header-inner { display: flex; justify-content: space-between; align-items: center; padding-top: 12px; padding-bottom: 12px; }
        .cgt-logo { display: flex; align-items: center; gap: 2px; text-decoration: none; }
        .cgt-logo-text { display: flex; flex-direction: column; line-height: 1; margin-top: 2px; }
        .cgt-logo-text-1 { font-size: 0.55rem; font-weight: 700; letter-spacing: 0.15em; color: #555; }
        .cgt-logo-text-2 { font-size: 1.3rem; font-weight: 900; color: #6b1122; letter-spacing: 0em; margin: 1px 0; }
        .cgt-logo-text-3 { font-size: 0.65rem; font-weight: 800; letter-spacing: 0.2em; color: #6b1122; }

        .hide-scrollbar::-webkit-scrollbar { display: none; }
        .hide-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }

        .cgt-nav { display: flex; gap: 28px; align-items: center; }
        .cgt-nav a { font-size: 0.72rem; font-weight: 800; color: #6b1122; text-transform: uppercase; text-decoration: none; letter-spacing: 0.05em; position: relative; padding-bottom: 4px; }
        .cgt-nav a.active { color: #006437; }
        .cgt-nav a.active::after { content: ''; position: absolute; bottom: 0; left: 0; right: 0; height: 2px; background: #006437; }
        .cgt-nav a:hover { color: #006437; }

        /* menu mobile */
        #cgt-menu-toggle { display: none; }
        .cgt-hamburger { display: none; cursor: pointer; color: #111; padding: 4px; }
        .cgt-mobile-actions { display: none; }
        @media (max-width: 992px) {
          .cgt-mobile-actions { display: flex; align-items: center; gap: 16px; position: relative; z-index: 60; }
          .cgt-socials-mobile { display: flex; align-items: center; gap: 12px; }
          .cgt-socials-mobile a { color: #111; display: flex; align-items: center; opacity: 0.8; transition: 0.2s; }
          .cgt-socials-mobile a:hover { opacity: 1; color: #00c96e; }
          .cgt-hamburger { display: block; position: relative; z-index: 60; }
          .cgt-nav { display: none; flex-direction: column; position: absolute; top: 100%; left: 0; width: 100%; background-color: #fff; padding: 24px; gap: 16px; box-shadow: 0 8px 32px rgba(0,0,0,0.1); border-top: 1px solid #eee; z-index: 50; }
          #cgt-menu-toggle:checked ~ .cgt-nav { display: flex; }
          .cgt-nav a { width: 100%; text-align: center; padding: 12px 0; border-bottom: 1px solid #f0f0f0; }
        }

        /* ── FOOTER ── */
        .cgt-footer { padding: 40px 0; font-size: 0.75rem; color: #555; }
        .cgt-footer-inner { display: flex; justify-content: space-between; align-items: center; border-top: 1px solid #ccc; padding-top: 25px; }
        .cgt-footer-logo { display: flex; align-items: center; gap: 2px; }
        .cgt-footer-brand { font-weight: 900; font-size: 0.95rem; color: #6b1122; letter-spacing: 0.02em; line-height: 1.2; margin-top: 2px; }
        .cgt-footer-brand span { display: block; font-size: 0.55rem; color: #777; letter-spacing: 0.1em; }
        .cgt-footer-links { display: flex; gap: 40px; }
        .cgt-footer-col p { font-size: 0.6rem; font-weight: 800; color: #888; text-transform: uppercase; margin: 0 0 4px 0; }
        .cgt-footer-col a, .cgt-footer-col span { color: #6b1122; font-weight: 700; text-decoration: none; font-size: 0.8rem; }
        .cgt-footer-copy { text-align: right; font-size: 0.65rem; font-weight: 700; color: #777; text-transform: uppercase; letter-spacing: 0.05em; }

        @media (max-width: 992px) {
          .cgt-footer-inner { flex-direction: column; gap: 24px; text-align: center; }
        }
        @media (max-width: 768px) {
          .cgt-topbar { flex-direction: row; justify-content: space-between; padding: 10px 16px; font-size: 0.65rem; gap: 12px; align-items: center; }
          .cgt-socials { display: none; }
          .cgt-topbar-left { white-space: normal; flex: 1; line-height: 1.4; display: block; }
          .cgt-topbar-dot { display: inline-block; margin-right: 4px; margin-top: 0; }
          .cgt-area-btn { padding: 6px 12px; font-size: 0.65rem; white-space: nowrap; flex-shrink: 0; align-self: stretch; display: flex; align-items: center; justify-content: center; }
        }
      `}} />

      {/* ─── 1. TOPBAR ────────────────────────────────────────── */}
      <div className="cgt-topbar">
        <div className="cgt-topbar-left">
          <span className="cgt-topbar-dot">●</span>
          <span>PRÓXIMO EVENTO: <span className="cgt-topbar-event">{topbarTexto}</span></span>
        </div>
        <div className="cgt-topbar-right hidden md:flex">
          <div className="cgt-socials">
            <a href="https://www.instagram.com/casaguerreirotricolor/" target="_blank" rel="noopener noreferrer">
              <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" /></svg>
            </a>
            <a href="https://www.youtube.com/@casaguerreirotricolor" target="_blank" rel="noopener noreferrer">
              <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" /></svg>
            </a>
            <a href="https://wa.me/5521996907307" target="_blank" rel="noopener noreferrer">
              <svg width="14" height="14" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" /></svg>
            </a>
          </div>
          <span className="cgt-area-btn opacity-80 cursor-default hover:bg-transparent hover:text-white border-transparent bg-transparent">
            <svg width="11" height="11" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2.5} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" /></svg>
            Sócio {usuario.nome.split(' ')[0]}
          </span>
        </div>
      </div>

      {/* HEADER OFICIAL */}
      <header className="cgt-header">
        <div className="cgt-container cgt-header-inner">
          <a href="/" className="cgt-logo">
            <img src="https://casadoguerreirotricolor.com.br/logo_pre.png" alt="Casa do Guerreiro Tricolor" style={{ width: '44px', height: '44px', objectFit: 'contain' }} />
            <div className="cgt-logo-text">
              <span className="cgt-logo-text-1">Casa do</span>
              <span className="cgt-logo-text-2 cgt-title-font">GUERREIRO</span>
              <span className="cgt-logo-text-3">Tricolor</span>
            </div>
          </a>

          <input type="checkbox" id="cgt-menu-toggle" />
          <div className="cgt-mobile-actions">
            <div className="cgt-socials-mobile">
              <a href="https://www.instagram.com/casaguerreirotricolor/" target="_blank" rel="noopener noreferrer">
                <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" /></svg>
              </a>
              <a href="https://www.youtube.com/@casaguerreirotricolor" target="_blank" rel="noopener noreferrer">
                <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" /></svg>
              </a>
              <a href="https://wa.me/5521996907307" target="_blank" rel="noopener noreferrer">
                <svg width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 0 1-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 0 1-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 0 1 2.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0 0 12.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 0 0 5.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 0 0-3.48-8.413z" /></svg>
              </a>
            </div>
            <label htmlFor="cgt-menu-toggle" className="cgt-hamburger">
              <svg width="24" height="24" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </label>
          </div>

          <nav className="cgt-nav">
            <a href="/" suppressHydrationWarning>INÍCIO</a>
            <a href="/#historia" suppressHydrationWarning>A CASA</a>
            <a href="/#planos" suppressHydrationWarning>SÓCIO</a>
            <a href="/#eventos" suppressHydrationWarning>EVENTOS</a>
            <a href="/noticias" suppressHydrationWarning>NOTÍCIAS</a>
            <a href="/podcasts" suppressHydrationWarning>PODCASTS</a>
            <a href="/loja" suppressHydrationWarning>LOJA</a>
            <a href="/painel" className="active" suppressHydrationWarning>ÁREA DO GUERREIRO</a>
            <button onClick={handleLogout} className="bg-[#8A1538] text-white px-4 py-2 rounded font-bold text-[10px] hover:bg-[#5a0c23] transition uppercase tracking-widest shadow-sm ml-2 md:ml-0">
              Sair
            </button>
          </nav>
        </div>
      </header>

      {/* SUB-HEADER MENU (Hover Dropdowns Controlados - Desktop) */}
      <div className="bg-[#004e2a] w-full border-t border-[#00381e] relative z-40 hidden sm:block shadow-md sticky top-[69px]">
        <div className="cgt-container flex items-center h-12">
          
          {/* ITEM 1 */}
          <div 
            className="relative h-full flex items-center"
            onMouseEnter={() => setMenuAberto('minhaconta')}
            onMouseLeave={() => setMenuAberto(null)}
          >
            <button className={`text-xs font-bold uppercase tracking-wider px-4 h-full transition-colors flex items-center gap-1 cursor-pointer outline-none ${['meu_perfil', 'meu_plano', 'pagamentos'].includes(activeTab) || menuAberto === 'minhaconta' ? 'bg-[#00381e] text-white' : 'text-white/90 hover:bg-[#00381e] hover:text-white'}`}>
              Minha Conta ▾
            </button>
            <div className={`absolute top-full left-0 w-48 bg-white border border-gray-200 shadow-xl rounded-b-lg transition-all duration-200 z-50 overflow-hidden ${menuAberto === 'minhaconta' ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
               <div className="flex flex-col py-1">
                 <button className={`w-full text-left px-4 py-2.5 text-xs font-bold transition-colors ${activeTab === 'meu_perfil' ? 'bg-[#e6f0eb] text-[#006437] border-l-4 border-[#006437]' : 'text-gray-700 hover:bg-gray-100 hover:text-[#006437] pl-5'}`} onClick={() => irParaAba('meu_perfil')}>👤 Meu Perfil</button>
                 <button className={`w-full text-left px-4 py-2.5 text-xs font-bold transition-colors ${activeTab === 'meu_plano' ? 'bg-[#e6f0eb] text-[#006437] border-l-4 border-[#006437]' : 'text-gray-700 hover:bg-gray-100 hover:text-[#006437] pl-5'}`} onClick={() => irParaAba('meu_plano')}>🎟️ Meu Plano</button>
                 <button className={`w-full text-left px-4 py-2.5 text-xs font-bold transition-colors ${activeTab === 'pagamentos' ? 'bg-[#e6f0eb] text-[#006437] border-l-4 border-[#006437]' : 'text-gray-700 hover:bg-gray-100 hover:text-[#006437] pl-5'}`} onClick={() => irParaAba('pagamentos')}>💳 Pagamentos</button>
               </div>
            </div>
          </div>

          {/* ITEM 2 */}
          <div 
            className="relative h-full flex items-center"
            onMouseEnter={() => setMenuAberto('beneficios')}
            onMouseLeave={() => setMenuAberto(null)}
          >
            <button className={`text-xs font-bold uppercase tracking-wider px-4 h-full transition-colors flex items-center gap-1 cursor-pointer outline-none ${['dependentes', 'convidados', 'aniversariantes'].includes(activeTab) || menuAberto === 'beneficios' ? 'bg-[#00381e] text-white' : 'text-white/90 hover:bg-[#00381e] hover:text-white'}`}>
              Benefícios & Rede ▾
            </button>
            <div className={`absolute top-full left-0 w-52 bg-white border border-gray-200 shadow-xl rounded-b-lg transition-all duration-200 z-50 overflow-hidden ${menuAberto === 'beneficios' ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
               <div className="flex flex-col py-1">
                 <button className={`w-full text-left px-4 py-2.5 text-xs font-bold transition-colors ${activeTab === 'dependentes' ? 'bg-[#e6f0eb] text-[#006437] border-l-4 border-[#006437]' : 'text-gray-700 hover:bg-gray-100 hover:text-[#006437] pl-5'}`} onClick={() => irParaAba('dependentes')}>👨‍👩‍👧‍👦 Dependentes</button>
                 <button className={`w-full text-left px-4 py-2.5 text-xs font-bold transition-colors ${activeTab === 'convidados' ? 'bg-[#e6f0eb] text-[#006437] border-l-4 border-[#006437]' : 'text-gray-700 hover:bg-gray-100 hover:text-[#006437] pl-5'}`} onClick={() => irParaAba('convidados')}>🤝 Convidados</button>
                 <button className={`w-full text-left px-4 py-2.5 text-xs font-bold transition-colors ${activeTab === 'aniversariantes' ? 'bg-[#e6f0eb] text-[#006437] border-l-4 border-[#006437]' : 'text-gray-700 hover:bg-gray-100 hover:text-[#006437] pl-5'}`} onClick={() => irParaAba('aniversariantes')}>🎉 Aniversariantes</button>
               </div>
            </div>
          </div>

          {/* ITEM 3 */}
          <div 
            className="relative h-full flex items-center"
            onMouseEnter={() => setMenuAberto('eventos')}
            onMouseLeave={() => setMenuAberto(null)}
          >
            <button className={`text-xs font-bold uppercase tracking-wider px-4 h-full transition-colors flex items-center gap-1 cursor-pointer outline-none ${['eventos', 'pedidos'].includes(activeTab) || menuAberto === 'eventos' ? 'bg-[#00381e] text-white' : 'text-white/90 hover:bg-[#00381e] hover:text-white'}`}>
              Eventos & Loja ▾
            </button>
            <div className={`absolute top-full left-0 w-48 bg-white border border-gray-200 shadow-xl rounded-b-lg transition-all duration-200 z-50 overflow-hidden ${menuAberto === 'eventos' ? 'opacity-100 visible' : 'opacity-0 invisible'}`}>
               <div className="flex flex-col py-1">
                 <button className={`w-full text-left px-4 py-2.5 text-xs font-bold transition-colors ${activeTab === 'eventos' ? 'bg-[#e6f0eb] text-[#006437] border-l-4 border-[#006437]' : 'text-gray-700 hover:bg-gray-100 hover:text-[#006437] pl-5'}`} onClick={() => irParaAba('eventos')}>📅 Calendário</button>
                 <button className={`w-full text-left px-4 py-2.5 text-xs font-bold transition-colors ${activeTab === 'pedidos' ? 'bg-[#e6f0eb] text-[#006437] border-l-4 border-[#006437]' : 'text-gray-700 hover:bg-gray-100 hover:text-[#006437] pl-5'}`} onClick={() => irParaAba('pedidos')}>🛍️ Pedidos da Loja</button>
               </div>
            </div>
          </div>

          {usuario?.isAdmin && (
            <button onClick={() => window.open('/admin', '_blank', 'noopener,noreferrer')} className="ml-auto px-4 py-1.5 rounded font-bold text-[10px] uppercase tracking-wider bg-[#8A1538] text-white hover:bg-[#5a0c23] transition shadow-sm">
              ⚙️ Admin
            </button>
          )}

        </div>
      </div>

      {/* MOBILE MENU (Custom Dropdown integrado ao Header) */}
      <div className="bg-[#004e2a] w-full border-t border-[#00381e] relative z-40 sticky top-[69px] sm:hidden">
        <button 
          onClick={() => setMenuAberto(menuAberto === 'mobile' ? null : 'mobile')}
          className="w-full px-4 py-3 bg-[#004e2a] text-[13px] font-bold text-white uppercase tracking-wider outline-none cursor-pointer flex items-center justify-center gap-2 relative z-50"
        >
          {tabTitles[activeTab] || 'Menu'}
          <svg className={`w-4 h-4 transition-transform duration-200 ${menuAberto === 'mobile' ? 'rotate-180' : ''}`} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M19 9l-7 7-7-7"></path></svg>
        </button>

        {/* OVERLAY OPACIDADE PARA FECHAR AO CLICAR FORA */}
        {menuAberto === 'mobile' && (
          <div className="fixed inset-0 top-[115px] bg-black/40 z-40" onClick={() => setMenuAberto(null)}></div>
        )}

        {/* DROPDOWN MENU MOBILE */}
        <div className={`absolute top-full left-0 w-full bg-white shadow-2xl border-t border-gray-100 z-50 overflow-y-auto transition-all duration-200 ${menuAberto === 'mobile' ? 'max-h-[calc(100dvh-115px)] opacity-100' : 'max-h-0 opacity-0 pointer-events-none'}`}>
          
          <div className="bg-gray-50 px-4 py-2 text-[10px] font-black text-gray-400 uppercase tracking-widest border-b border-gray-100">Minha Conta</div>
          <button className={`w-full text-left py-3.5 text-xs font-bold transition-colors border-b border-gray-50 ${activeTab === 'meu_perfil' ? 'bg-[#e6f0eb] text-[#006437] border-l-4 border-[#006437] pl-4 pr-5' : 'text-gray-700 active:bg-gray-100 px-5'}`} onClick={() => irParaAba('meu_perfil')}>👤 Meu Perfil</button>
          <button className={`w-full text-left py-3.5 text-xs font-bold transition-colors border-b border-gray-50 ${activeTab === 'meu_plano' ? 'bg-[#e6f0eb] text-[#006437] border-l-4 border-[#006437] pl-4 pr-5' : 'text-gray-700 active:bg-gray-100 px-5'}`} onClick={() => irParaAba('meu_plano')}>🎟️ Meu Plano</button>
          <button className={`w-full text-left py-3.5 text-xs font-bold transition-colors border-b border-gray-50 ${activeTab === 'pagamentos' ? 'bg-[#e6f0eb] text-[#006437] border-l-4 border-[#006437] pl-4 pr-5' : 'text-gray-700 active:bg-gray-100 px-5'}`} onClick={() => irParaAba('pagamentos')}>💳 Pagamentos</button>

          <div className="bg-gray-50 px-4 py-2 text-[10px] font-black text-gray-400 uppercase tracking-widest border-b border-gray-100 border-t border-gray-100 mt-1">Benefícios & Rede</div>
          <button className={`w-full text-left py-3.5 text-xs font-bold transition-colors border-b border-gray-50 ${activeTab === 'dependentes' ? 'bg-[#e6f0eb] text-[#006437] border-l-4 border-[#006437] pl-4 pr-5' : 'text-gray-700 active:bg-gray-100 px-5'}`} onClick={() => irParaAba('dependentes')}>👨‍👩‍👧‍👦 Dependentes</button>
          <button className={`w-full text-left py-3.5 text-xs font-bold transition-colors border-b border-gray-50 ${activeTab === 'convidados' ? 'bg-[#e6f0eb] text-[#006437] border-l-4 border-[#006437] pl-4 pr-5' : 'text-gray-700 active:bg-gray-100 px-5'}`} onClick={() => irParaAba('convidados')}>🤝 Convidados</button>
          <button className={`w-full text-left py-3.5 text-xs font-bold transition-colors border-b border-gray-50 ${activeTab === 'aniversariantes' ? 'bg-[#e6f0eb] text-[#006437] border-l-4 border-[#006437] pl-4 pr-5' : 'text-gray-700 active:bg-gray-100 px-5'}`} onClick={() => irParaAba('aniversariantes')}>🎉 Aniversariantes</button>

          <div className="bg-gray-50 px-4 py-2 text-[10px] font-black text-gray-400 uppercase tracking-widest border-b border-gray-100 border-t border-gray-100 mt-1">Eventos & Loja</div>
          <button className={`w-full text-left py-3.5 text-xs font-bold transition-colors border-b border-gray-50 ${activeTab === 'eventos' ? 'bg-[#e6f0eb] text-[#006437] border-l-4 border-[#006437] pl-4 pr-5' : 'text-gray-700 active:bg-gray-100 px-5'}`} onClick={() => irParaAba('eventos')}>📅 Calendário</button>
          <button className={`w-full text-left py-3.5 text-xs font-bold transition-colors ${activeTab === 'pedidos' ? 'bg-[#e6f0eb] text-[#006437] border-l-4 border-[#006437] pl-4 pr-5' : 'text-gray-700 active:bg-gray-100 px-5'}`} onClick={() => irParaAba('pedidos')}>🛍️ Pedidos da Loja</button>
        </div>
      </div>

      <main className="cgt-container pt-10 pb-16 flex-grow w-full">
        <div className="flex flex-col lg:flex-row gap-8 lg:gap-10 w-full">

          {/* Coluna Esquerda: Dados do Sócio */}
          <div className="w-full lg:w-[400px] shrink-0 space-y-8 self-start">

            {/* CARTEIRINHA VIRTUAL ATUALIZADA (MODERNA E CLARA) */}
            {(usuario.plano || 'Guerreiro da Casa') === 'Não Sócio' ? (
              <div className="relative w-full max-w-[400px] mx-auto bg-gray-50 p-8 rounded-2xl border border-gray-200 text-center shadow-sm">
                <span className="text-4xl mb-4 block">🎟️</span>
                <h3 className="font-black text-gray-800 text-xl uppercase mb-2">Sem Plano Ativo</h3>
                <p className="text-sm text-gray-500 font-medium mb-6">Assine um plano de sócio para desbloquear sua carteirinha virtual e benefícios exclusivos.</p>
                <button onClick={() => setActiveTab('meu_plano')} className="bg-[#006437] text-white font-bold py-3 px-6 rounded-lg hover:bg-[#004d2a] transition uppercase text-sm shadow-sm w-full">
                  Ver Planos
                </button>
              </div>
            ) : (
              <>
                <div className="relative w-full max-w-[400px] mx-auto h-[250px] [perspective:1000px]">
                  <div id="carteirinha-container-3d" className={`w-full h-full relative [transform-style:preserve-3d] transition-transform duration-700 ${isFlipped ? '[transform:rotateY(180deg)]' : ''}`}>

                    {/* FRENTE DA CARTEIRINHA */}
                    <div id="carteirinha-frente" className={`absolute inset-0 w-full h-full bg-white rounded-2xl shadow-xl border border-gray-200 [backface-visibility:hidden] [-webkit-backface-visibility:hidden] [transform:translateZ(0)] [-webkit-transform:translateZ(0)] ${isFlipped ? 'pointer-events-none z-0' : 'z-10'}`}>
                      <div className="w-full h-full rounded-2xl p-5 pb-6 flex flex-col justify-between overflow-hidden relative">

                        {/* Faixa Superior Tricolor Moderna */}
                        <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-[#006437] via-white to-[#8A1538]"></div>

                        {/* Fundo sutil / Marca d'água */}
                        <div className="absolute -bottom-10 -right-10 opacity-[0.03] pointer-events-none">
                          <img src="https://casadoguerreirotricolor.com.br/logo_pre.png" alt="Watermark" crossOrigin="anonymous" className="w-64 object-contain grayscale" />
                        </div>

                        {/* Header e Botão de Virar */}
                        <div className="flex justify-between items-start relative z-10">
                          <div>
                            <span className="text-[10px] font-black uppercase tracking-widest text-[#8A1538]">Carteira de Sócio</span>
                            <h3 className="text-xl font-black text-gray-900 uppercase leading-none mt-1 tracking-tighter italic">Casa do Guerreiro</h3>
                          </div>
                          <button onClick={() => setIsFlipped(true)} className="btn-virar-carteira text-gray-400 hover:text-[#006437] transition z-20 cursor-pointer bg-gray-50 p-2 rounded-full hover:bg-gray-100 shadow-sm border border-gray-200" title="Virar Carteirinha">
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M3 10h10a8 8 0 018 8v2M3 10l6 6m-6-6l6-6"></path></svg>
                          </button>
                        </div>

                        {/* Miolo: Foto, Dados e QR Code */}
                        <div className="flex gap-4 items-center relative z-10 mt-3 flex-grow">
                          {/* Foto do Sócio */}
                          <label className="relative cursor-pointer shrink-0 w-[80px] h-[105px] bg-gray-50 border border-gray-200 shadow-sm overflow-hidden group rounded-lg" title="Clique para alterar sua foto">
                            <input type="file" className="hidden" accept="image/*" onChange={handleFotoUpload} />
                            {usuario.foto_url ? (
                              <img src={usuario.foto_url} alt="Sócio" crossOrigin="anonymous" className="w-full h-full object-cover" />
                            ) : (
                              <div className="w-full h-full flex items-center justify-center text-gray-300 text-3xl">👤</div>
                            )}
                            <div className="absolute inset-0 bg-black/60 opacity-0 group-hover:opacity-100 flex flex-col items-center justify-center transition-opacity duration-200">
                              <span className="text-white text-[10px] font-bold uppercase text-center px-1">Trocar<br />Foto</span>
                            </div>
                          </label>

                          {/* Dados Centrais */}
                          <div className="flex flex-col justify-center space-y-2 flex-1">
                            <div>
                              <p className="text-[10px] font-bold text-[#006437] uppercase tracking-wider mb-0.5">Nome do Titular</p>
                              <p className="font-black text-[13px] text-gray-800 uppercase leading-tight line-clamp-2 pr-1" title={usuario.nome}>{usuario.nome}</p>
                            </div>
                            <div className="grid grid-cols-2 gap-2">
                              <div>
                                <p className="text-[9px] font-bold text-gray-500 uppercase tracking-wider mb-0.5">Matrícula</p>
                                <p className="font-bold text-xs text-gray-900">#{String(usuario.id).padStart(5, '0')}</p>
                              </div>
                              <div>
                                <p className="text-[9px] font-bold text-gray-500 uppercase tracking-wider mb-0.5">Admissão</p>
                                <p className="font-bold text-xs text-gray-900">{usuario.data_cadastro ? new Date(usuario.data_cadastro).toLocaleDateString('pt-BR') : '04/02/2019'}</p>
                              </div>
                            </div>
                          </div>

                          {/* QR Code na Frente (Substituindo o antigo código de barras) */}
                          <div className="shrink-0 flex flex-col items-center">
                            <div className="bg-white p-1 border border-gray-200 rounded-lg shadow-sm">
                              <img src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=CGT-${String(usuario.id).padStart(5, '0')}&color=000000`} alt="QR Code" crossOrigin="anonymous" className="h-16 w-16 object-contain" />
                            </div>
                            <p className="text-[8px] font-bold text-gray-400 mt-1.5 uppercase tracking-widest">Acesso</p>
                          </div>
                        </div>

                        {/* Rodapé da Frente */}
                        <div className="mt-2 pt-3 border-t border-gray-100 flex justify-between items-end relative z-10">
                          <div>
                            <p className="text-[9px] font-bold text-gray-400 uppercase tracking-wider mb-0.5">Plano Vigente</p>
                            <p className="font-black text-xs uppercase text-[#8A1538]">
                              {usuario.plano || 'Guerreiro da Casa'}
                            </p>
                          </div>
                          <div className="text-right flex items-center gap-1.5">
                            <span className={`relative flex h-2.5 w-2.5`}>
                              <span className={`animate-ping absolute inline-flex h-full w-full rounded-full opacity-75 ${usuario.status_socio === 'ativo' ? 'bg-[#00c96e]' : 'bg-yellow-400'}`}></span>
                              <span className={`relative inline-flex rounded-full h-2.5 w-2.5 ${usuario.status_socio === 'ativo' ? 'bg-[#00c96e]' : 'bg-yellow-500'}`}></span>
                            </span>
                            <p className={`font-black text-xs uppercase tracking-wider ${usuario.status_socio === 'ativo' ? 'text-[#006437]' : 'text-yellow-600'}`}>
                              {usuario.status_socio || 'Inativo'}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* VERSO DA CARTEIRINHA */}
                    <div id="carteirinha-verso" className={`absolute inset-0 w-full h-full bg-white rounded-2xl shadow-xl border border-gray-200 [backface-visibility:hidden] [-webkit-backface-visibility:hidden] [transform:rotateY(180deg)_translateZ(0)] [-webkit-transform:rotateY(180deg)_translateZ(0)] ${!isFlipped ? 'pointer-events-none z-0' : 'z-10'}`}>
                      <div className="w-full h-full rounded-2xl p-6 flex flex-col items-center justify-center overflow-hidden relative">

                        {/* Faixa Inferior Tricolor (Verso) */}
                        <div className="absolute bottom-0 left-0 w-full h-2 bg-gradient-to-r from-[#8A1538] via-white to-[#006437]"></div>

                        {/* Botão de Virar de volta */}
                        <button onClick={() => setIsFlipped(false)} className="btn-virar-carteira absolute top-5 right-5 text-gray-400 hover:text-[#8A1538] transition z-20 cursor-pointer bg-gray-50 p-2 rounded-full hover:bg-gray-100 shadow-sm border border-gray-200" title="Virar Carteirinha">
                          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2.5" d="M21 10h-10a8 8 0 00-8 8v2M21 10l-6 6m6-6l-6-6"></path></svg>
                        </button>

                        {/* Conteúdo em Duas Colunas */}
                        <div className="flex flex-row items-center justify-center w-full h-full gap-4 px-2 mt-4">
                          
                          {/* Coluna 1: Logo e Institucional */}
                          <div className="flex-1 flex flex-col items-center justify-center text-center">
                            <img src="https://casadoguerreirotricolor.com.br/logo_pre.png" alt="Logo Sócio" className="w-20 object-contain relative z-10 mb-2 opacity-90" />
                            <p className="font-black text-[11px] sm:text-[13px] text-gray-700 uppercase tracking-tighter leading-tight">Sócio Casa do Guerreiro Tricolor Nova Iguaçu</p>
                          </div>

                          {/* Linha Divisória */}
                          <div className="w-px h-28 bg-gray-200 shadow-sm rounded-full"></div>

                          {/* Coluna 2: QR Code de Validação */}
                          <div className="flex-1 flex flex-col items-center justify-center">
                            <p className="text-[9px] font-bold text-[#8A1538] uppercase tracking-widest mb-1.5 text-center leading-tight">Para uso do<br/>Parceiro</p>
                            <div className="bg-white p-1.5 border border-dashed border-[#006437]/40 rounded-lg shadow-sm mb-1.5">
                              <img src={`https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=https://casadoguerreirotricolor.com.br/validar/${usuario.id}&color=000000`} alt="QR Validação" crossOrigin="anonymous" className="h-16 w-16 object-contain" />
                            </div>
                            <p className="font-black text-[9px] text-[#006437] uppercase tracking-tight">Escanear p/ Validar</p>
                          </div>

                        </div>
                      </div>
                    </div>

                  </div>
                </div>

                {/* BOTÕES DE WALLET E PDF */}
                <div className="w-full max-w-[400px] mx-auto mt-6 flex items-center justify-between bg-white px-5 py-3 rounded-xl border border-gray-200 shadow-[0_4px_14px_rgba(0,0,0,0.03)]">
                  <span className="text-[10px] font-bold text-gray-500 uppercase tracking-widest mt-0.5">Adicionar à carteira</span>
                  <div className="flex gap-2">
                    <button onClick={handleExportarWallet} className="w-9 h-9 flex items-center justify-center bg-black text-white rounded-lg hover:bg-gray-800 transition" title="Adicionar ao Apple Wallet">
                      <svg className="w-5 h-5 mb-0.5" viewBox="0 0 24 24" fill="currentColor"><path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91 1.63.07 2.87.73 3.65 1.88-3.08 1.81-2.58 5.73.53 6.94-.74 1.85-1.57 3.69-2.39 4.93zM12.03 6.36A3.89 3.89 0 0014.88 4.5c.34-1.51-.23-3.1-1.38-4.05C12.39 1.45 10.74.8 9.27 2.37c-.36 1.48.24 3.03 1.34 3.99 1.05.9 2.59 1.41 3.51.13h-.01z" /></svg>
                    </button>
                    <button onClick={handleExportarGoogleWallet} className="w-9 h-9 flex items-center justify-center bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition border border-gray-200" title="Adicionar ao Google Wallet">
                      <svg className="w-4 h-4 mb-0.5 text-gray-700" viewBox="0 0 24 24" fill="currentColor"><path d="M21.35 11.1h-9.17v2.73h6.51c-.33 3.81-3.5 5.44-6.5 5.44C8.36 19.27 5 16.25 5 12c0-4.1 3.2-7.27 7.2-7.27 3.09 0 4.9 1.97 4.9 1.97L19 4.72S16.56 2 12.1 2C6.42 2 2.03 6.8 2.03 12c0 5.05 4.13 10 10.22 10 5.35 0 9.25-3.67 9.25-9.09 0-1.15-.15-1.81-.15-1.81Z" /></svg>
                    </button>
                    <button onClick={handleExportarPDF} className="w-9 h-9 flex items-center justify-center bg-red-50 text-[#8A1538] rounded-lg hover:bg-red-100 transition border border-red-100" title="Baixar como PDF">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5"><path strokeLinecap="round" strokeLinejoin="round" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path></svg>
                    </button>
                    <button onClick={handleInstalarApp} className="w-9 h-9 flex items-center justify-center bg-[#006437]/10 text-[#006437] rounded-lg hover:bg-[#006437]/20 transition border border-[#006437]/20" title="Instalar Aplicativo (Offline)">
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2.5"><path strokeLinecap="round" strokeLinejoin="round" d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"></path></svg>
                    </button>
                  </div>
                </div>
              </>
            )}

          </div>

          {/* Coluna Direita: Conteúdo Dinâmico das Abas */}
          <div className="w-full lg:w-[calc(100%-440px)] lg:flex-1 min-w-0">

            {/* ABA: MEU PERFIL */}
            {activeTab === 'meu_perfil' && (
              <div className="bg-[#fdfdfd] p-6 md:p-8 rounded-xl shadow-[0_10px_25px_rgba(0,0,0,0.04)] border border-[#ddd] mb-6 w-full">
                <div className="cgt-section-header">
                  <div className="cgt-section-line left"></div>
                  <div className="cgt-section-title">MEU PERFIL</div>
                  <div className="cgt-section-line right"></div>
                </div>

                <form className="space-y-8" onSubmit={handleAtualizarPerfil}>
                  {/* DADOS PESSOAIS */}
                  <div>
                    <h3 className="text-xl font-black text-[#8A1538] uppercase italic tracking-tighter mb-4">Dados Pessoais</h3>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                      <div>
                        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Nome Completo</label>
                        <input type="text" name="nome" required defaultValue={usuario.nome} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]" />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">CPF</label>
                        <input type="text" name="cpf" defaultValue={usuario.cpf ? formatarCPF(usuario.cpf) : ''} onChange={(e) => e.target.value = formatarCPF(e.target.value)} maxLength={14} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]" />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">E-mail</label>
                        <input type="email" name="email" required defaultValue={usuario.email} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]" />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Sexo</label>
                        <select name="sexo" defaultValue={usuario.sexo || ''} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]">
                          <option value="">Selecione...</option>
                          <option value="Masculino">Masculino</option>
                          <option value="Feminino">Feminino</option>
                          <option value="Outro">Outro</option>
                          <option value="Prefiro não informar">Prefiro não informar</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Nascimento</label>
                        <input type="date" name="nascimento" defaultValue={usuario.nascimento ? usuario.nascimento.substring(0, 10) : ''} className="block w-full appearance-none bg-white px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437] box-border" />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Celular</label>
                        <input type="text" name="celular" defaultValue={usuario.celular ? formatarCelular(usuario.celular) : ''} onChange={(e) => e.target.value = formatarCelular(e.target.value)} maxLength={15} placeholder="(00) 00000-0000" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]" />
                      </div>
                      <div className="md:col-span-2">
                        <p className="text-sm font-bold text-gray-700 mt-2">Sócio desde: <span className="text-[#006437]">{usuario.data_cadastro ? new Date(usuario.data_cadastro).toLocaleDateString('pt-BR') : '03/01/2019'}</span></p>
                      </div>
                    </div>
                  </div>

                  {/* CADASTRO COMPLEMENTAR */}
                  <div>
                    <h3 className="text-xl font-black text-[#8A1538] uppercase italic tracking-tighter mb-4">Cadastro Complementar</h3>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                      <div>
                        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Nacionalidade</label>
                        <input type="text" name="nacionalidade" defaultValue={usuario.nacionalidade || 'Brasileira'} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]" />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">RG</label>
                        <input type="text" name="rg" defaultValue={usuario.rg || ''} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]" />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">RG UF</label>
                        <select name="rg_uf" defaultValue={usuario.rg_uf || ''} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437] bg-white">
                          <option value="">UF</option>
                          <option value="AC">AC</option>
                          <option value="AL">AL</option>
                          <option value="AP">AP</option>
                          <option value="AM">AM</option>
                          <option value="BA">BA</option>
                          <option value="CE">CE</option>
                          <option value="DF">DF</option>
                          <option value="ES">ES</option>
                          <option value="GO">GO</option>
                          <option value="MA">MA</option>
                          <option value="MT">MT</option>
                          <option value="MS">MS</option>
                          <option value="MG">MG</option>
                          <option value="PA">PA</option>
                          <option value="PB">PB</option>
                          <option value="PR">PR</option>
                          <option value="PE">PE</option>
                          <option value="PI">PI</option>
                          <option value="RJ">RJ</option>
                          <option value="RN">RN</option>
                          <option value="RS">RS</option>
                          <option value="RO">RO</option>
                          <option value="RR">RR</option>
                          <option value="SC">SC</option>
                          <option value="SP">SP</option>
                          <option value="SE">SE</option>
                          <option value="TO">TO</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">RG Expedidor</label>
                        <input type="text" name="rg_expedidor" defaultValue={usuario.rg_expedidor || ''} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]" />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Estado Civil</label>
                        <select name="estado_civil" defaultValue={usuario.estado_civil || ''} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]">
                          <option value="">Selecione...</option>
                          <option value="Solteiro(a)">Solteiro(a)</option>
                          <option value="Casado(a)">Casado(a)</option>
                          <option value="Divorciado(a)">Divorciado(a)</option>
                          <option value="Viúvo(a)">Viúvo(a)</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Escolaridade</label>
                        <select name="escolaridade" defaultValue={usuario.escolaridade || ''} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]">
                          <option value="">Selecione...</option>
                          <option value="Ensino Médio">Ensino Médio</option>
                          <option value="Superior Incompleto">Superior Incompleto</option>
                          <option value="Superior Completo">Superior Completo</option>
                          <option value="Pós-graduação">Pós-graduação</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Tel. Residencial</label>
                        <input type="text" name="telefone_residencial" defaultValue={usuario.telefone_residencial || ''} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]" />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Camisa ST</label>
                        <select name="tamanho_camisa" defaultValue={usuario.tamanho_camisa || ''} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]">
                          <option value="">Selecione...</option>
                          <option value="P">P</option><option value="M">M</option><option value="G">G</option><option value="GG">GG</option><option value="XG">XG</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Short</label>
                        <select name="tamanho_short" defaultValue={usuario.tamanho_short || ''} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]">
                          <option value="">Selecione...</option>
                          <option value="P">P</option><option value="M">M</option><option value="G">G</option><option value="GG">GG</option><option value="XG">XG</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Calçado</label>
                        <input type="number" name="tamanho_calcado" defaultValue={usuario.tamanho_calcado || ''} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]" />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Frequência em jogos</label>
                        <select name="frequencia_jogos" defaultValue={usuario.frequencia_jogos || ''} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]">
                          <option value="">Selecione...</option>
                          <option value="Sempre">Sempre</option><option value="Às vezes">Às vezes</option><option value="Raramente">Raramente</option><option value="Nunca fui">Nunca fui</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Religião</label>
                        <input type="text" name="religiao" defaultValue={usuario.religiao || ''} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]" />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Tem filhos?</label>
                        <select name="tem_filhos" value={temFilhosSelecionado !== null ? temFilhosSelecionado : (usuario.tem_filhos || '')} onChange={(e) => {
                          setTemFilhosSelecionado(e.target.value);
                          if (e.target.value === 'Não') {
                            const qtdInput = document.getElementById('qtd_filhos_input') as HTMLInputElement;
                            if (qtdInput) qtdInput.value = '0';
                          }
                        }} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]">
                          <option value="">Selecione...</option>
                          <option value="Não">Não</option><option value="Sim">Sim</option>
                        </select>
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Qtd. de Filhos</label>
                        <input id="qtd_filhos_input" type="number" name="qtd_filhos" defaultValue={usuario.qtd_filhos || 0} disabled={(temFilhosSelecionado !== null ? temFilhosSelecionado : usuario.tem_filhos) === 'Não'} className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437] ${(temFilhosSelecionado !== null ? temFilhosSelecionado : usuario.tem_filhos) === 'Não' ? 'bg-gray-100 cursor-not-allowed text-gray-400' : ''}`} />
                      </div>
                      <div>
                        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Sócio Torcedor Flu?</label>
                        <select name="socio_torcedor_flu" defaultValue={usuario.socio_torcedor_flu ? '1' : ''} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]">
                          <option value="">Não</option>
                          <option value="1">Sim</option>
                        </select>
                      </div>
                    </div>
                  </div>

                  {/* ENDEREÇO */}
                  <div>
                    <h3 className="text-xl font-black text-[#8A1538] uppercase italic tracking-tighter mb-4">Meu Endereço</h3>
                    <div>
                      <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Endereço Cadastrado</label>
                      <textarea name="endereco" defaultValue={usuario.endereco || ''} rows={2} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]" placeholder="Rua, Número, Complemento, Bairro, Cidade, Estado, CEP"></textarea>
                    </div>
                  </div>

                  {/* SEGURANÇA */}
                  <div>
                    <h3 className="text-xl font-black text-[#8A1538] uppercase italic tracking-tighter mb-4">Segurança</h3>
                    <p className="text-sm text-gray-500 mb-4">É recomendável usar uma senha forte que você não esteja usando em nenhum outro lugar.</p>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 items-end">
                      <div>
                        <label className="block text-xs font-medium text-gray-500 uppercase tracking-wider mb-1">Senha Atual</label>
                        <input type="password" defaultValue="************" className="w-full px-3 py-2 border border-gray-300 rounded-lg bg-gray-50 text-gray-500 cursor-not-allowed" readOnly />
                      </div>
                      <div>
                        <button type="button" onClick={() => setIsSenhaModalOpen(true)} className="w-full h-[42px] flex items-center justify-center bg-white text-[#8A1538] font-bold rounded-lg hover:bg-gray-50 transition shadow-sm uppercase tracking-wide text-sm border border-gray-300">
                          ALTERAR SENHA
                        </button>
                      </div>
                    </div>
                  </div>

                  <div className="pt-4 border-t border-gray-200">
                    <button type="submit" className="bg-[#006437] text-white font-bold py-3 px-8 rounded-lg hover:bg-[#004d2a] transition shadow-sm uppercase tracking-wide text-sm">
                      SALVAR ALTERAÇÕES
                    </button>
                  </div>
                </form>
              </div>
            )}

            {/* ABA: MEU PLANO */}
            {activeTab === 'meu_plano' && (
              <div className="bg-[#fdfdfd] p-6 md:p-8 rounded-xl shadow-[0_10px_25px_rgba(0,0,0,0.04)] border border-[#ddd] mb-6 w-full">
                <div className="cgt-section-header">
                  <div className="cgt-section-line left"></div>
                  <div className="cgt-section-title">MEU PLANO</div>
                  <div className="cgt-section-line right"></div>
                </div>

                <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 mb-6 relative overflow-hidden">
                  <div className="absolute top-0 right-0 w-32 h-32 bg-[#8A1538] rounded-full opacity-5 -mr-10 -mt-10"></div>
                  <h3 className="text-lg font-bold text-gray-700 mb-2 relative z-10">Plano Atual</h3>
                  <p className="text-3xl md:text-4xl font-black text-[#8A1538] uppercase italic relative z-10">{usuario.plano || 'Guerreiro da Casa'}</p>
                  <p className="text-sm text-gray-500 mt-2 relative z-10">
                    {usuario.plano === 'Não Sócio' 
                      ? 'Você não possui um plano de sócio ativo. Faça um upgrade para obter benefícios!' 
                      : 'Você tem acesso a todos os benefícios desta categoria.'}
                  </p>
                </div>

                <div className="bg-gray-50 p-6 rounded-xl border border-gray-200 mb-6">
                  <h3 className="text-lg font-bold text-gray-700 mb-2">Status da Assinatura</h3>
                  <div className="flex flex-wrap items-center gap-2">
                    <p className={`font-black uppercase text-2xl ${usuario.status_socio === 'ativo' ? 'text-[#006437]' : 'text-yellow-600'}`}>
                      {usuario.status_socio || 'Inativo'}
                    </p>
                    {usuario.mp_assinatura_id && usuario.status_socio === 'ativo' && (
                      <span className="text-xs bg-green-100 text-[#006437] font-bold px-2.5 py-1 rounded-full flex items-center gap-1 border border-green-200">
                        <span>🔄</span> Assinatura Recorrente Automática
                      </span>
                    )}
                  </div>
                </div>

                <div className="flex flex-col sm:flex-row gap-4">
                  {usuario.plano !== 'Não Sócio' && (
                    <button
                      onClick={() => {
                        setMensagemPagamento(null);
                        setIsPagamentoMensalidadeModalOpen(true);
                      }}
                      className="w-full sm:w-auto bg-[#8A1538] text-white font-bold py-3 px-8 rounded-lg hover:bg-[#5a0c23] transition shadow-md uppercase tracking-wide text-sm flex items-center justify-center gap-2"
                    >
                      <span>💳 Pagar / Assinar Mensalidade</span>
                    </button>
                  )}
                  {usuario.plano !== 'Lenda Tricolor' && (
                    <button onClick={() => setIsUpgradeModalOpen(true)} className="w-full sm:w-auto bg-white border border-[#8A1538] text-[#8A1538] font-bold py-3 px-8 rounded-lg hover:bg-gray-50 transition shadow-sm uppercase tracking-wide text-sm">
                      {usuario.plano === 'Não Sócio' ? '⭐ Assinar um Plano' : '⬆️ Solicitar Upgrade'}
                    </button>
                  )}
                </div>
              </div>
            )}

            {/* ABA: EVENTOS E JOGOS */}
            {activeTab === 'eventos' && (
              <div className="bg-[#fdfdfd] p-6 md:p-8 rounded-xl shadow-[0_10px_25px_rgba(0,0,0,0.04)] border border-[#ddd] mb-6 w-full">
                <div className="cgt-section-header">
                  <div className="cgt-section-line left"></div>
                  <div className="cgt-section-title">CALENDÁRIO DE EVENTOS</div>
                  <div className="cgt-section-line right"></div>
                </div>

                {eventos.length === 0 ? (
                  <div className="text-center py-12 bg-gray-50 rounded-lg border border-gray-200">
                    <p className="text-gray-500 font-medium">Nenhum evento agendado no momento.</p>
                  </div>
                ) : (
                  <div className="space-y-4">
                    {eventos.map((evento: any) => (
                      <div key={evento.id} className="flex flex-col sm:flex-row justify-between items-start sm:items-center p-4 bg-gray-50 rounded-lg border border-gray-100 gap-4 transition hover:shadow-md">
                        <div className="flex items-center gap-4 flex-1">
                          <div className="relative group cursor-pointer shrink-0" onClick={() => setImagemModal(evento.banner_url || 'https://static.vecteezy.com/ti/fotos-gratis/t1/8641767-centro-de-campo-de-futebol-fundo-esporte-jogo-e-conceito-atletico-renderizacao-ilustracao-em-3d-foto.jpg')}>
                            <img src={evento.banner_url || 'https://static.vecteezy.com/ti/fotos-gratis/t1/8641767-centro-de-campo-de-futebol-fundo-esporte-jogo-e-conceito-atletico-renderizacao-ilustracao-em-3d-foto.jpg'} alt={evento.titulo} className="w-16 h-16 object-cover rounded-md shadow-sm border border-gray-200 bg-[#006437] group-hover:opacity-75 transition" />
                            <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition">
                              <span className="text-white text-xs font-bold drop-shadow-md bg-black/50 px-1.5 py-0.5 rounded">🔍</span>
                            </div>
                          </div>
                          <div>
                            <span className="bg-red-100 text-[#8A1538] text-[10px] font-bold px-2 py-0.5 rounded uppercase mb-1 inline-block">{evento.tipo}</span>
                            <h4 className="font-bold text-gray-800 text-lg leading-tight">{evento.titulo}</h4>
                            <p className="text-xs text-gray-500 font-medium mt-1">{new Date(evento.data_evento).toLocaleString('pt-BR')} • {evento.local}</p>
                          </div>
                        </div>
                        {presencas.includes(evento.id) ? (
                          <button onClick={() => handleDesconfirmar(evento.id)} className="mt-3 w-full sm:w-auto sm:mt-0 bg-gray-200 text-gray-700 text-sm font-bold px-5 py-2.5 rounded-lg hover:bg-red-100 hover:text-red-700 transition" title="Clique para cancelar a presença">
                            ✅ Presença Confirmada
                          </button>
                        ) : (
                          <button onClick={() => handleConfirmar(evento.id)} className="mt-3 w-full sm:w-auto sm:mt-0 bg-[#006437] text-white text-sm font-bold px-5 py-2.5 rounded-lg hover:bg-[#004d2a] transition shadow-sm uppercase tracking-wide">
                            Confirmar Presença
                          </button>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}

            {/* ABA: PAGAMENTOS */}
            {activeTab === 'pagamentos' && (
              <div className="bg-[#fdfdfd] p-6 md:p-8 rounded-xl shadow-[0_10px_25px_rgba(0,0,0,0.04)] border border-[#ddd] mb-6 w-full">
                <div className="cgt-section-header">
                  <div className="cgt-section-line left"></div>
                  <div className="cgt-section-title">HISTÓRICO DE PAGAMENTOS</div>
                  <div className="cgt-section-line right"></div>
                </div>

                {pagamentosSocio.length === 0 ? (
                  <div className="text-center py-12 bg-gray-50 rounded-lg border border-gray-200">
                    <p className="text-gray-500 font-medium">Nenhum pagamento registrado recentemente.</p>
                  </div>
                ) : (
                  <div className="overflow-x-auto rounded-lg border border-gray-200">
                    <table className="min-w-full text-left whitespace-nowrap">
                      <thead>
                        <tr className="bg-gray-100 text-gray-600">
                          <th className="px-4 py-3 text-xs font-bold uppercase tracking-wider">Data</th>
                          <th className="px-4 py-3 text-xs font-bold uppercase tracking-wider">Referência</th>
                          <th className="px-4 py-3 text-xs font-bold uppercase tracking-wider">Descrição</th>
                          <th className="px-4 py-3 text-xs font-bold uppercase tracking-wider text-right">Valor</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 bg-white">
                        {pagamentosSocio.map(pag => (
                          <tr key={pag.id} className="hover:bg-gray-50 transition">
                            <td className="px-4 py-3 text-sm font-medium text-gray-800">{new Date(pag.data_pagamento).toLocaleDateString('pt-BR')}</td>
                            <td className="px-4 py-3 text-sm font-bold text-gray-600">{pag.referencia_mes_ano}</td>
                            <td className="px-4 py-3 text-sm text-gray-600">{pag.descricao}</td>
                            <td className="px-4 py-3 text-sm font-black text-[#006437] text-right">R$ {Number(pag.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* ABA: PEDIDOS DA LOJA */}
            {activeTab === 'pedidos' && (
              <div className="bg-[#fdfdfd] p-6 md:p-8 rounded-xl shadow-[0_10px_25px_rgba(0,0,0,0.04)] border border-[#ddd] mb-6 w-full">
                <div className="cgt-section-header">
                  <div className="cgt-section-line left"></div>
                  <div className="cgt-section-title">MEUS PEDIDOS DA LOJA</div>
                  <div className="cgt-section-line right"></div>
                </div>

                {pedidosLoja.length === 0 ? (
                  <div className="text-center py-12 bg-gray-50 rounded-lg border border-gray-200">
                    <p className="text-gray-500 font-medium">Você ainda não possui pedidos na loja.</p>
                  </div>
                ) : (
                  <div className="overflow-x-auto rounded-lg border border-gray-200">
                    <table className="min-w-full text-left whitespace-nowrap">
                      <thead>
                        <tr className="bg-gray-100 text-gray-600">
                          <th className="px-4 py-3 text-xs font-bold uppercase tracking-wider">Pedido #</th>
                          <th className="px-4 py-3 text-xs font-bold uppercase tracking-wider">Data</th>
                          <th className="px-4 py-3 text-xs font-bold uppercase tracking-wider">Status</th>
                          <th className="px-4 py-3 text-xs font-bold uppercase tracking-wider text-right">Total</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 bg-white">
                        {pedidosLoja.map(pedido => (
                          <tr key={pedido.id} className="hover:bg-gray-50 transition">
                            <td className="px-4 py-3 text-sm font-bold text-gray-600">#{String(pedido.id).padStart(4, '0')}</td>
                            <td className="px-4 py-3 text-sm font-medium text-gray-800">
                              {(() => {
                                const raw = pedido.data_pedido || pedido.criado_em || pedido.data || pedido.created_at;
                                if (!raw) return '-';
                                const d = new Date(raw);
                                return isNaN(d.getTime()) ? '-' : d.toLocaleDateString('pt-BR');
                              })()}
                            </td>
                            <td className="px-4 py-3 text-sm font-medium">
                              <span className={`px-2 py-1 rounded text-xs font-bold ${pedido.status === 'Pendente' ? 'bg-yellow-100 text-yellow-700' : pedido.status === 'Pago' ? 'bg-green-100 text-green-700' : 'bg-blue-100 text-blue-700'}`}>
                                {pedido.status}
                              </span>
                            </td>
                            <td className="px-4 py-3 text-sm font-black text-[#006437] text-right">R$ {Number(pedido.total).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            )}

            {/* ABA: CONVIDADOS */}
            {activeTab === 'convidados' && (
              <div className="bg-[#fdfdfd] p-6 md:p-8 rounded-xl shadow-[0_10px_25px_rgba(0,0,0,0.04)] border border-[#ddd] mb-6 w-full">
                <div className="cgt-section-header">
                  <div className="cgt-section-line left"></div>
                  <div className="cgt-section-title">MEUS CONVIDADOS</div>
                  <div className="cgt-section-line right"></div>
                </div>

                <div className="bg-blue-50 p-4 rounded-lg border border-blue-100 mb-6 text-blue-800 text-sm font-medium">
                  O seu plano atual (<strong>{usuario.plano || 'Guerreiro da Casa'}</strong>) dá direito a <strong>{limiteConvidados}</strong> convidado(s).
                </div>

                {limiteConvidados === 0 ? (
                  <div className="text-center py-12 bg-gray-50 rounded-lg border border-gray-200">
                    <p className="text-gray-500 font-medium">O seu plano atual não dá direito a convidados. Fale com a diretoria para fazer um upgrade!</p>
                  </div>
                ) : (
                  <>
                    {convidadosSocio.length === 0 ? (
                      <div className="text-center py-12 bg-gray-50 rounded-lg border border-gray-200 mb-6">
                        <p className="text-gray-500 font-medium">Nenhum convidado cadastrado.</p>
                      </div>
                    ) : (
                      <div className="space-y-4 mb-6">
                        {convidadosSocio.map((conv, index) => (
                          <div key={conv.id} className="flex justify-between items-center p-4 bg-gray-50 rounded-lg border border-gray-200 shadow-sm">
                            <div>
                              <p className="font-bold text-gray-800 text-sm">{index + 1}. {conv.nome}</p>
                              {conv.cpf && <p className="text-xs text-gray-500 mt-1">CPF: {conv.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")}</p>}
                            </div>
                            <button onClick={() => handleRemoverConvidado(conv.id)} className="text-xs font-bold text-red-600 bg-red-100 hover:bg-red-200 px-3 py-1.5 rounded transition uppercase tracking-wider">
                              Remover
                            </button>
                          </div>
                        ))}
                      </div>
                    )}

                    {convidadosSocio.length < limiteConvidados && (
                      <button onClick={() => setIsConvidadoModalOpen(true)} className="w-full sm:w-auto bg-[#006437] text-white font-bold py-2.5 px-6 rounded-lg hover:bg-[#004d2a] transition shadow-sm uppercase tracking-wide text-xs">
                        ➕ Adicionar Novo Convidado ({limiteConvidados - convidadosSocio.length} restante)
                      </button>
                    )}
                  </>
                )}
              </div>
            )}

            {/* ABA: DEPENDENTES */}
            {activeTab === 'dependentes' && (
              <div className="bg-[#fdfdfd] p-6 md:p-8 rounded-xl shadow-[0_10px_25px_rgba(0,0,0,0.04)] border border-[#ddd] mb-6 w-full">
                <div className="cgt-section-header">
                  <div className="cgt-section-line left"></div>
                  <div className="cgt-section-title">MEUS DEPENDENTES</div>
                  <div className="cgt-section-line right"></div>
                </div>

                <div className="bg-green-50 p-4 rounded-lg border border-green-100 mb-6 text-green-800 text-sm font-medium">
                  Adicione seus dependentes (filhos, cônjuge, etc) para que eles tenham benefícios estendidos vinculados ao seu plano.
                </div>

                {(usuario.plano || 'Guerreiro da Casa') === 'Não Sócio' ? (
                  <div className="text-center py-12 bg-gray-50 rounded-lg border border-gray-200">
                    <p className="text-gray-500 font-medium">Você precisa ser um sócio assinante para adicionar dependentes. Faça um upgrade de plano!</p>
                  </div>
                ) : (
                  <>
                    {dependentesSocio.length === 0 ? (
                      <div className="text-center py-12 bg-gray-50 rounded-lg border border-gray-200 mb-6">
                        <p className="text-gray-500 font-medium">Nenhum dependente cadastrado.</p>
                      </div>
                    ) : (
                      <div className="space-y-4 mb-6">
                        {dependentesSocio.map((dep, index) => (
                          <div key={dep.id} className="flex justify-between items-center p-4 bg-gray-50 rounded-lg border border-gray-200 shadow-sm">
                            <div>
                              <p className="font-bold text-gray-800 text-sm">{index + 1}. {dep.nome}</p>
                              <div className="flex flex-wrap gap-x-4 gap-y-1 mt-1">
                                {dep.cpf && <p className="text-xs text-gray-500"><strong>CPF:</strong> {dep.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, "$1.$2.$3-$4")}</p>}
                                {dep.parentesco && <p className="text-xs text-gray-500"><strong>Grau:</strong> {dep.parentesco}</p>}
                                {dep.nascimento && <p className="text-xs text-gray-500"><strong>Nasc:</strong> {new Date(dep.nascimento).toLocaleDateString('pt-BR', { timeZone: 'UTC' })}</p>}
                              </div>
                            </div>
                            <button onClick={() => handleRemoverDependente(dep.id)} className="text-xs font-bold text-red-600 bg-red-100 hover:bg-red-200 px-3 py-1.5 rounded transition uppercase tracking-wider">
                              Remover
                            </button>
                          </div>
                        ))}
                      </div>
                    )}

                    <button onClick={() => setIsDependenteModalOpen(true)} className="w-full sm:w-auto bg-[#006437] text-white font-bold py-2.5 px-6 rounded-lg hover:bg-[#004d2a] transition shadow-sm uppercase tracking-wide text-xs">
                      ➕ Adicionar Novo Dependente
                    </button>
                  </>
                )}
              </div>
            )}

            {/* ABA: ANIVERSARIANTES */}
            {activeTab === 'aniversariantes' && (
              <div className="bg-[#fdfdfd] p-6 md:p-8 rounded-xl shadow-[0_10px_25px_rgba(0,0,0,0.04)] border border-[#ddd] mb-6 w-full">
                <div className="cgt-section-header">
                  <div className="cgt-section-line left"></div>
                  <div className="cgt-section-title">ANIVERSARIANTES DO MÊS</div>
                  <div className="cgt-section-line right"></div>
                </div>

                {aniversariantes.length === 0 ? (
                  <div className="text-center py-12 bg-gray-50 rounded-lg border border-gray-200">
                    <p className="text-gray-500 font-medium">Nenhum guerreiro(a) faz aniversário este mês.</p>
                  </div>
                ) : (
                  <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                    {aniversariantes.map((aniv) => {
                      const dataNasc = new Date(aniv.nascimento);
                      const dia = dataNasc.getUTCDate();
                      return (
                        <div key={aniv.id} className="bg-gray-50 p-4 rounded-xl border border-gray-200 flex items-center gap-4 hover:shadow-md transition">
                          <div className="w-14 h-14 bg-gray-300 rounded-full overflow-hidden shrink-0 border-2 border-white shadow-sm flex items-center justify-center">
                            {aniv.foto_url ? (
                              <img src={aniv.foto_url} alt={aniv.nome} className="w-full h-full object-cover" />
                            ) : (
                              <span className="text-2xl">👤</span>
                            )}
                          </div>
                          <div>
                            <p className="font-bold text-gray-800 text-sm leading-tight line-clamp-1" title={aniv.nome}>{aniv.nome}</p>
                            <p className="text-[#8A1538] text-xs font-black mt-1 uppercase tracking-wider">Dia {dia}</p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
            )}

          </div>

        </div>
      </main>

      {/* MODAL DE IMAGEM AMPLIADA */}
      {imagemModal && (
        <div className="fixed inset-0 z-[100] bg-black/90 flex items-center justify-center p-4 cursor-pointer" onClick={() => setImagemModal(null)}>
          <span className="absolute top-4 right-6 text-white text-5xl font-light hover:text-gray-300 transition">&times;</span>
          <img src={imagemModal || ''} alt="Banner ampliado" className="relative max-w-full max-h-[90vh] rounded-lg shadow-2xl z-10 object-contain cursor-default" onClick={(e) => e.stopPropagation()} />
        </div>
      )}

      {/* MODAL DE ALTERAR SENHA */}
      {isSenhaModalOpen && (
        <div className="fixed inset-0 z-[100] bg-black/60 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md p-6 sm:p-8 relative">
            {!usuario?.precisaTrocarSenha && (
              <button onClick={() => { setIsSenhaModalOpen(false); setErroSenha(''); }} className="absolute top-4 right-6 text-gray-400 hover:text-gray-800 text-3xl font-light transition">&times;</button>
            )}
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b pb-2">
              {usuario?.precisaTrocarSenha ? 'Crie uma Nova Senha' : 'Alterar Senha'}
            </h2>

            <form onSubmit={handleAlterarSenha} className="space-y-5">
              {erroSenha && <div className="bg-red-50 text-red-700 p-3 rounded-lg text-sm font-medium border border-red-100">{erroSenha}</div>}

              {usuario?.precisaTrocarSenha && (
                <div className="bg-yellow-50 text-yellow-800 p-3 rounded-lg text-sm font-medium border border-yellow-200 mb-4">
                  Como este é o seu primeiro acesso, por motivos de segurança, você precisa criar uma nova senha para o seu painel.
                </div>
              )}

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Senha Atual</label>
                <input type="password" required value={senhaAtual} onChange={(e) => setSenhaAtual(e.target.value)} disabled={usuario?.precisaTrocarSenha} className={`w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437] ${usuario?.precisaTrocarSenha ? 'bg-gray-100 text-gray-400 cursor-not-allowed' : ''}`} />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Nova Senha</label>
                <input type="password" required value={novaSenha} onChange={(e) => setNovaSenha(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]" />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Confirmar Nova Senha</label>
                <input type="password" required value={confirmarNovaSenha} onChange={(e) => setConfirmarNovaSenha(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]" />
              </div>

              <div className="pt-2">
                <button type="submit" className="w-full bg-[#006437] text-white font-bold py-3 rounded-lg hover:bg-[#004d2a] transition-colors uppercase tracking-wide text-sm shadow-sm">
                  Atualizar Senha
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* MODAL DE ADICIONAR CONVIDADO */}
      {isConvidadoModalOpen && (
        <div className="fixed inset-0 z-[100] bg-black/60 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md p-6 sm:p-8 relative">
            <button onClick={() => { setIsConvidadoModalOpen(false); setErroConvidado(''); }} className="absolute top-4 right-6 text-gray-400 hover:text-gray-800 text-3xl font-light transition">&times;</button>
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b pb-2">Novo Convidado</h2>

            <form onSubmit={handleAdicionarConvidado} className="space-y-5">
              {erroConvidado && <div className="bg-red-50 text-red-700 p-3 rounded-lg text-sm font-medium border border-red-100">{erroConvidado}</div>}

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Nome Completo do Convidado</label>
                <input type="text" required value={convidadoNome} onChange={(e) => setConvidadoNome(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]" />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">CPF (Opcional)</label>
                <input type="text" maxLength={14} value={convidadoCpf} onChange={(e) => setConvidadoCpf(e.target.value.replace(/\D/g, ''))} placeholder="Apenas números" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]" />
              </div>

              <div className="pt-2">
                <button type="submit" className="w-full bg-[#006437] text-white font-bold py-3 rounded-lg hover:bg-[#004d2a] transition-colors uppercase tracking-wide text-sm shadow-sm">
                  Adicionar Convidado
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* MODAL DE ADICIONAR DEPENDENTE */}
      {isDependenteModalOpen && (
        <div className="fixed inset-0 z-[100] bg-black/60 flex items-center justify-center p-4">
          <div className="bg-white rounded-xl shadow-2xl w-full max-w-md p-6 sm:p-8 relative">
            <button onClick={() => { setIsDependenteModalOpen(false); setErroDependente(''); }} className="absolute top-4 right-6 text-gray-400 hover:text-gray-800 text-3xl font-light transition">&times;</button>
            <h2 className="text-2xl font-bold text-gray-800 mb-6 border-b pb-2">Novo Dependente</h2>

            <form onSubmit={handleAdicionarDependente} className="space-y-5">
              {erroDependente && <div className="bg-red-50 text-red-700 p-3 rounded-lg text-sm font-medium border border-red-100">{erroDependente}</div>}

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Nome Completo</label>
                <input type="text" required value={dependenteNome} onChange={(e) => setDependenteNome(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]" />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">CPF (Opcional)</label>
                  <input type="text" maxLength={14} value={dependenteCpf} onChange={(e) => setDependenteCpf(e.target.value.replace(/\D/g, ''))} placeholder="Apenas números" className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Nascimento (Opcional)</label>
                  <input type="date" value={dependenteNascimento} onChange={(e) => setDependenteNascimento(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437]" />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Grau de Parentesco</label>
                <select value={dependenteParentesco} onChange={(e) => setDependenteParentesco(e.target.value)} className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-[#006437] focus:border-[#006437] bg-white">
                  <option value="">Selecione...</option>
                  <option value="Cônjuge">Cônjuge</option>
                  <option value="Filho(a)">Filho(a)</option>
                  <option value="Enteado(a)">Enteado(a)</option>
                  <option value="Pai/Mãe">Pai/Mãe</option>
                  <option value="Outro">Outro</option>
                </select>
              </div>

              <div className="pt-2">
                <button type="submit" className="w-full bg-[#006437] text-white font-bold py-3 rounded-lg hover:bg-[#004d2a] transition-colors uppercase tracking-wide text-sm shadow-sm">
                  Adicionar Dependente
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* MODAL DE PAGAMENTO DE MENSALIDADE (MERCADO PAGO) */}
      {isPagamentoMensalidadeModalOpen && (
        <div className="fixed inset-0 z-[100] bg-black/70 backdrop-blur-sm flex items-center justify-center p-4">
          <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl overflow-hidden border border-gray-200 relative animate-fadeIn">
            {/* Cabeçalho Tricolor */}
            <div className="bg-[#6b1122] text-white p-6 relative">
              <button
                onClick={() => setIsPagamentoMensalidadeModalOpen(false)}
                className="absolute top-4 right-5 text-white/80 hover:text-white text-3xl font-light transition"
              >
                &times;
              </button>
              <div className="flex items-center gap-2 mb-1">
                <span className="text-xs bg-[#00c96e] text-black font-black px-2 py-0.5 rounded uppercase tracking-wider">Gateway Oficial</span>
                <span className="text-xs text-white/80 font-bold uppercase tracking-widest">Mercado Pago</span>
              </div>
              <h2 className="text-2xl font-black uppercase tracking-tight">Pagamento da Mensalidade</h2>
              <p className="text-white/80 text-xs mt-1">Mantenha sua carteirinha de sócio ativa e desfrute de todos os benefícios exclusivos.</p>
            </div>

            <div className="p-6 md:p-8 space-y-6">
              {/* Informações do Plano do Sócio */}
              <div className="bg-gradient-to-r from-gray-50 to-[#fdfbf7] border border-[#e8e4dc] rounded-xl p-4 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3">
                <div>
                  <span className="text-[11px] font-bold text-gray-500 uppercase tracking-wider">Seu Plano</span>
                  <div className="text-xl font-black text-[#6b1122] uppercase">{usuario.plano || 'Guerreiro da Casa'}</div>
                </div>
                <div className="sm:text-right">
                  <span className="text-[11px] font-bold text-gray-500 uppercase tracking-wider">Valor Mensal</span>
                  <div className="text-2xl font-black text-[#006437]">R$ {getValorPlanoAtual().toFixed(2)}<span className="text-xs text-gray-500 font-normal">/mês</span></div>
                </div>
              </div>

              {/* Mensagem de alerta se houver */}
              {mensagemPagamento && (
                <div className="bg-amber-50 border border-amber-200 text-amber-900 rounded-xl p-4 text-xs font-medium flex items-start gap-2.5">
                  <span className="text-base leading-none">⚠️</span>
                  <div>{mensagemPagamento}</div>
                </div>
              )}

              {/* Opções de Pagamento */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Opção 1: Recorrente Automático */}
                <div className="border-2 border-[#006437] rounded-xl p-5 bg-green-50/40 flex flex-col justify-between relative hover:shadow-md transition">
                  <span className="absolute -top-3 left-4 bg-[#006437] text-white text-[10px] font-black uppercase px-2 py-0.5 rounded-full shadow-sm">
                    Recomendado
                  </span>
                  <div>
                    <div className="flex items-center gap-2 mb-2 mt-1">
                      <span className="text-xl">🔄</span>
                      <h3 className="font-black text-[#006437] text-base uppercase">Assinatura Recorrente</h3>
                    </div>
                    <p className="text-xs text-gray-600 mb-4 leading-relaxed">
                      Cobrança automática mensal no cartão de crédito pelo Mercado Pago. Seu status nunca expira e você não precisa lembrar de pagar todo mês.
                    </p>
                  </div>
                  <button
                    onClick={handlePagarMensalidadeRecorrente}
                    disabled={loadingPagamentoMensalidade !== null}
                    className="w-full bg-[#006437] text-white font-black text-xs uppercase tracking-wider py-3 px-4 rounded-lg hover:bg-[#004d2a] transition shadow-md disabled:opacity-50 flex items-center justify-center gap-2"
                  >
                    {loadingPagamentoMensalidade === 'recorrente' ? (
                      <>
                        <svg className="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                        <span>Gerando Assinatura...</span>
                      </>
                    ) : (
                      <>
                        <span>Ativar Recorrente</span>
                        <span className="text-[10px] bg-white/20 px-1 rounded">›</span>
                      </>
                    )}
                  </button>
                </div>

                {/* Opção 2: Avulso (PIX / Boleto / Cartão) */}
                <div className="border border-gray-200 rounded-xl p-5 bg-white flex flex-col justify-between hover:border-gray-300 hover:shadow-md transition">
                  <div>
                    <div className="flex items-center gap-2 mb-2">
                      <span className="text-xl">⚡</span>
                      <h3 className="font-black text-gray-800 text-base uppercase">Pagar Mês Atual</h3>
                    </div>
                    <p className="text-xs text-gray-600 mb-4 leading-relaxed">
                      Pagamento único para a mensalidade vigente. Escolha entre <strong>PIX imediato com QR Code</strong>, Boleto ou Cartão no checkout.
                    </p>
                  </div>
                  <button
                    onClick={handlePagarMensalidadeAvulsa}
                    disabled={loadingPagamentoMensalidade !== null}
                    className="w-full bg-[#6b1122] text-white font-black text-xs uppercase tracking-wider py-3 px-4 rounded-lg hover:bg-[#520c19] transition shadow-md disabled:opacity-50 flex items-center justify-center gap-2"
                  >
                    {loadingPagamentoMensalidade === 'avulso' ? (
                      <>
                        <svg className="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24"><circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle><path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                        <span>Gerando Pagamento...</span>
                      </>
                    ) : (
                      <>
                        <span>Pagar Este Mês</span>
                        <span className="text-[10px] bg-white/20 px-1 rounded">›</span>
                      </>
                    )}
                  </button>
                </div>
              </div>

              {/* Rodapé de Segurança */}
              <div className="pt-2 text-center text-[11px] text-gray-500 flex items-center justify-center gap-1.5 border-t border-gray-100">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="#009ee3"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"/></svg>
                <span>Ambiente Seguro criptografado processado pelo <strong>Mercado Pago</strong></span>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* MODAL DE UPGRADE DE PLANO */}
      {isUpgradeModalOpen && (
        <div className="fixed inset-0 z-[100] bg-black/60 flex items-center justify-center p-4">
          <div className="bg-gray-100 rounded-xl shadow-2xl w-full max-w-6xl max-h-[95vh] overflow-y-auto p-4 sm:p-8 relative">
            <button onClick={() => setIsUpgradeModalOpen(false)} className="absolute top-4 right-6 text-gray-400 hover:text-gray-800 text-3xl font-light transition z-50">&times;</button>
            <div className="text-center mb-8 pt-4">
              <h2 className="text-3xl font-black text-[#8A1538] uppercase italic tracking-tighter">Escolha seu Novo Plano</h2>
              <p className="text-gray-600 mt-2 text-sm sm:text-base">Mude de categoria e aproveite mais benefícios exclusivos na Casa do Guerreiro.</p>
            </div>

            {/* Container dos Planos (Carrossel no celular, Grid no Desktop) */}
            <div className="flex overflow-x-auto md:grid md:grid-cols-3 gap-8 snap-x snap-mandatory pb-4 md:pb-8 hide-scrollbar pt-8 px-2 md:px-4">

              {/* Plano 1 */}
              <div className="min-w-[85%] sm:min-w-[300px] md:min-w-0 snap-center bg-white rounded-2xl shadow-lg border-t-8 border-[#006437] overflow-hidden flex flex-col transform md:hover:-translate-y-2 transition duration-300">
                <div className="p-8 text-center flex flex-col flex-grow">
                  <h4 className="text-2xl font-black uppercase text-gray-800">Guerreiro da Casa</h4>
                  <p className="text-gray-500 mt-2 text-sm">A porta de entrada para a família Tricolor.</p>
                  <div className="my-6"><span className="text-5xl font-black text-[#8A1538]">R$50</span><span className="text-gray-500 text-sm">/mês</span></div>
                  <ul className="text-left space-y-3 mb-8 text-gray-600 text-sm font-medium flex-grow">
                    <li>✅ Assistir jogos e área de jogos</li>
                    <li>✅ Fique por dentro de todas as novidades</li>
                    <li>✅ Prioridade em caravanas</li>
                  </ul>
                  {(usuario.plano || 'Guerreiro da Casa') === 'Guerreiro da Casa' ? (
                    <button disabled className="mt-auto block w-full bg-gray-200 text-gray-500 font-bold py-3 rounded uppercase text-sm cursor-not-allowed">Seu Plano Atual</button>
                  ) : (
                    <button onClick={() => solicitarUpgradeWhatsApp('Guerreiro da Casa')} className="mt-auto block w-full bg-[#006437] text-white font-bold py-3 rounded hover:bg-[#004d2a] transition uppercase text-sm shadow-sm">Mudar Plano</button>
                  )}
                </div>
              </div>

              {/* Plano 2 */}
              <div className="min-w-[85%] sm:min-w-[300px] md:min-w-0 snap-center bg-[#8A1538] rounded-2xl shadow-xl border-t-8 border-[#006437] overflow-hidden relative flex flex-col md:scale-105 z-10 transform md:hover:-translate-y-2 transition duration-300">
                <div className="absolute top-0 right-0 bg-[#006437] text-white text-xs font-bold px-3 py-1 rounded-bl-lg uppercase">Mais Popular</div>
                <div className="p-8 text-center text-white flex flex-col flex-grow">
                  <h4 className="text-2xl font-black uppercase">Sangue Grená</h4>
                  <p className="text-gray-300 mt-2 text-sm">Para quem vive a Casa intensamente.</p>
                  <div className="my-6"><span className="text-5xl font-black">R$90</span><span className="text-gray-300 text-sm">/mês</span></div>
                  <ul className="text-left space-y-3 mb-8 text-gray-200 text-sm font-medium flex-grow">
                    <li>✅ Todos os benefícios do Guerreiro da Casa</li>
                    <li>✅ Leve 2 amigos na Casa (1x/mês)</li>
                    <li>✅ Kit surpresa anual da Casa do Guerreiro</li>
                  </ul>
                  {(usuario.plano || 'Guerreiro da Casa') === 'Sangue Grená' ? (
                    <button disabled className="mt-auto block w-full bg-[#5a0c23] text-gray-300 font-bold py-3 rounded uppercase text-sm cursor-not-allowed">Seu Plano Atual</button>
                  ) : (
                    <button onClick={() => solicitarUpgradeWhatsApp('Sangue Grená')} className="mt-auto block w-full bg-[#006437] text-white font-bold py-3 rounded hover:bg-[#004d2a] transition uppercase text-sm shadow-sm">Fazer Upgrade</button>
                  )}
                </div>
              </div>

              {/* Plano 3 */}
              <div className="min-w-[85%] sm:min-w-[300px] md:min-w-0 snap-center bg-white rounded-2xl shadow-lg border-t-8 border-gray-400 overflow-hidden flex flex-col transform md:hover:-translate-y-2 transition duration-300">
                <div className="p-8 text-center flex flex-col flex-grow">
                  <h4 className="text-2xl font-black uppercase text-gray-800">Lenda Tricolor</h4>
                  <p className="text-gray-500 mt-2 text-sm">A experiência máxima da Casa do Guerreiro.</p>
                  <div className="my-6"><span className="text-5xl font-black text-[#8A1538]">R$120</span><span className="text-gray-500 text-sm">/mês</span></div>
                  <ul className="text-left space-y-3 mb-8 text-gray-600 text-sm font-medium flex-grow">
                    <li>✅ Todos os benefícios dos planos anteriores</li>
                    <li>✅ Leve 3 amigos na Casa (2x/mês)</li>
                    <li>✅ Sorteio anual de Camisa Oficial Autografada</li>
                  </ul>
                  {(usuario.plano || 'Guerreiro da Casa') === 'Lenda Tricolor' ? (
                    <button disabled className="mt-auto block w-full bg-gray-200 text-gray-500 font-bold py-3 rounded uppercase text-sm cursor-not-allowed">Seu Plano Atual</button>
                  ) : (
                    <button onClick={() => solicitarUpgradeWhatsApp('Lenda Tricolor')} className="mt-auto block w-full bg-[#006437] text-white font-bold py-3 rounded hover:bg-[#004d2a] transition uppercase text-sm shadow-sm">Fazer Upgrade</button>
                  )}
                </div>
              </div>

            </div>
          </div>
        </div>
      )}

      {/* ─── FOOTER ───────────────────────────────────────── */}
      <footer className="cgt-footer mt-auto">
        <div className="cgt-container">
          <div className="cgt-footer-inner">
            <div className="cgt-footer-logo">
              <img src="https://casadoguerreirotricolor.com.br/logo_pre.png" alt="Casa do Guerreiro Tricolor" style={{ width: '36px', height: '36px', objectFit: 'contain' }} />
              <div className="cgt-footer-brand cgt-title-font">
                <span>CASA DO</span> GUERREIRO TRICOLOR
              </div>
            </div>

            <div className="cgt-footer-links">
              <div className="cgt-footer-col">
                <p>FALE CONOSCO</p>
                <a href="https://wa.me/5521996907307">(21) 99690-7307</a>
              </div>
              <div className="cgt-footer-col">
                <p>ONDE ESTAMOS</p>
                <a href="https://maps.app.goo.gl/z59FvHbW75VRD7xt9" target="_blank" rel="noopener noreferrer">Av. Luís de Matos, 30 - Luz, Nova Iguaçu - RJ, 26255-510</a>
              </div>
            </div>

            <div className="cgt-footer-copy">
              © 2026 Casa do Guerreiro Tricolor.<br />Todos os direitos reservados.
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}